// Auto-generated from the GeoNames Canadian postal code dataset
// (https://download.geonames.org/export/zip/ — CC-BY 4.0).
// Every Canadian forward sortation area (FSA — the first 3 characters of a
// postal code) mapped to [latitude, longitude, area name].
// Regenerate with scripts/gen-fsa.mjs if it ever needs a refresh:
//   node scripts/gen-fsa.mjs <path-to-CA.txt> src/lib/fsaData.ts

export const FSA_COORDS: Record<string, [number, number, string]> = {
  A0A: [47.219, -53.145, 'Southeastern Avalon Peninsula (Ferryland)'],
  A0B: [47.327, -53.661, 'Western Avalon Peninsula (Argentia)'],
  A0C: [48.384, -53.908, 'Bonavista Peninsula (Bonavista)'],
  A0E: [47.561, -54.780, 'Burin Peninsula (Marystown)'],
  A0G: [48.866, -54.730, 'Northeast Newfoundland (Lewisporte)'],
  A0H: [48.431, -56.176, 'Central Newfoundland (Bishops Falls)'],
  A0J: [49.507, -56.262, 'Northern Newfoundland (Springdale)'],
  A0K: [52.736, -57.983, 'Northwest Newfoundland/Eastern Labrador (Mary\'s Harbour)'],
  A0L: [48.944, -58.065, 'Western Newfoundland (Lark Harbour)'],
  A0M: [47.804, -58.387, 'Southwestern Newfoundland (Channel-Port aux Basques)'],
  A0N: [48.087, -57.823, 'Port au Port Peninsula region (St. George\'s)'],
  A0P: [54.955, -61.602, 'Central Labrador (Happy Valley-Goose Bay)'],
  A0R: [53.540, -65.112, 'North/Western Labrador (Churchill Falls)'],
  A1A: [47.599, -52.693, 'St. John\'s North'],
  A1B: [47.570, -52.780, 'St. John\'s Northwest Newfoundland & Labrador Provincial Government'],
  A1C: [47.512, -52.673, 'St. John\'s North Central'],
  A1E: [47.533, -52.760, 'St. John\'s Central'],
  A1G: [47.506, -52.760, 'St. John\'s South'],
  A1H: [47.483, -52.842, 'St. John\'s Southwest'],
  A1K: [47.667, -52.731, 'Torbay'],
  A1L: [47.529, -52.881, 'Paradise'],
  A1M: [47.621, -52.832, 'Portugal Cove-St. Philips'],
  A1N: [47.519, -52.812, 'Mount Pearl'],
  A1S: [47.421, -52.808, 'Goulds'],
  A1V: [48.968, -54.591, 'Gander'],
  A1W: [47.510, -52.945, 'Manuels'],
  A1X: [47.500, -52.998, 'Conception Bay'],
  A1Y: [47.711, -53.295, 'Carbonear'],
  A2A: [48.933, -55.665, 'Grand Falls'],
  A2B: [48.950, -55.665, 'Windsor'],
  A2H: [48.916, -57.797, 'Corner Brook'],
  A2N: [48.550, -58.582, 'Stephenville'],
  A2V: [52.952, -66.933, 'Labrador City'],
  A5A: [48.167, -53.965, 'Clarenville'],
  A8A: [49.167, -57.432, 'Deer Lake'],
  B0C: [46.648, -60.540, 'North Victoria County (Dingwall)'],
  B0E: [46.113, -61.025, 'West Cape Breton Island (Baddeck)'],
  B0H: [45.334, -61.833, 'Canso region (Havre Boucher)'],
  B0J: [44.942, -62.647, 'Mainland east shore (Lunenburg)'],
  B0K: [45.614, -62.951, 'Southern Northumberland Strait (Pictou)'],
  B0L: [45.691, -64.364, 'Isthmus of Chignecto (River Hébert)'],
  B0M: [45.535, -64.039, 'Cobequid Bay north shore (Springhill)'],
  B0N: [45.096, -63.470, 'Hants County (Shubenacadie)'],
  B0P: [45.033, -64.657, 'Kings County (Kingston)'],
  B0R: [44.600, -64.744, 'West Lunenburg County (New Germany)'],
  B0S: [44.686, -65.300, 'West Annapolis County (Middleton)'],
  B0T: [44.080, -65.118, 'Queens County (Shelburne)'],
  B0V: [44.534, -65.778, 'Digby Neck (Digby)'],
  B0W: [44.049, -65.755, 'Southwest Mainland (Weymouth)'],
  B1A: [46.197, -59.957, 'Glace Bay'],
  B1B: [46.117, -59.914, 'Port Morien'],
  B1C: [45.949, -59.974, 'Louisbourg'],
  B1E: [46.184, -60.017, 'Reserve Mines'],
  B1G: [46.217, -60.015, 'Dominion'],
  B1H: [46.250, -60.082, 'New Waterford'],
  B1J: [45.983, -60.365, 'East Bay'],
  B1K: [45.967, -60.232, 'Marion Bridge'],
  B1L: [46.063, -60.205, 'Sydney Southwest'],
  B1M: [46.127, -60.070, 'Sydney East'],
  B1N: [46.197, -60.156, 'Sydney North'],
  B1P: [46.134, -60.175, 'Sydney North Central'],
  B1R: [46.128, -60.291, 'Sydney West'],
  B1S: [46.111, -60.209, 'Sydney Central'],
  B1T: [45.967, -60.715, 'Christmas Island'],
  B1V: [46.244, -60.231, 'North Sydney North'],
  B1W: [45.933, -60.644, 'Eskasoni'],
  B1X: [46.290, -60.470, 'Big Bras d\'Or'],
  B1Y: [46.254, -60.357, 'Alder Point'],
  B2A: [46.117, -60.377, 'North Sydney South Central'],
  B2C: [45.995, -60.842, 'Iona'],
  B2E: [45.750, -60.615, 'Loch Lomond'],
  B2G: [45.617, -61.999, 'Antigonish'],
  B2H: [45.583, -62.649, 'New Glasgow'],
  B2J: [45.707, -60.467, 'Fourchu'],
  B2N: [45.367, -63.265, 'Truro'],
  B2R: [44.760, -63.553, 'Waverley'],
  B2S: [45.021, -63.534, 'Lantz'],
  B2T: [44.875, -63.469, 'Enfield'],
  B2V: [44.653, -63.478, 'Dartmouth Morris Lake'],
  B2W: [44.675, -63.508, 'Dartmouth East Central'],
  B2X: [44.702, -63.533, 'Dartmouth North Central'],
  B2Y: [44.664, -63.545, 'Dartmouth South Central'],
  B2Z: [44.723, -63.422, 'Dartmouth East'],
  B3A: [44.682, -63.577, 'Dartmouth Southwest'],
  B3B: [44.709, -63.587, 'Dartmouth Northwest'],
  B3E: [44.772, -63.336, 'Porters Lake'],
  B3G: [44.617, -63.482, 'Eastern Passage'],
  B3H: [44.634, -63.582, 'Halifax Lower Harbour'],
  B3J: [44.645, -63.576, 'Halifax Mid-Harbour Nova Scotia Provincial Government'],
  B3K: [44.662, -63.602, 'Halifax Upper Harbour'],
  B3L: [44.651, -63.615, 'Halifax Central'],
  B3M: [44.678, -63.658, 'Halifax Bedford Basin'],
  B3N: [44.631, -63.641, 'Halifax South Central'],
  B3P: [44.614, -63.595, 'Halifax North West Arm'],
  B3R: [44.594, -63.603, 'Halifax South'],
  B3S: [44.653, -63.667, 'Halifax West'],
  B3T: [44.568, -63.731, 'Lakeside'],
  B3V: [44.520, -63.606, 'Harrietsfield'],
  B3Z: [44.639, -63.869, 'Tantallon'],
  B4A: [44.723, -63.656, 'Bedford Southeast'],
  B4B: [44.751, -63.771, 'Bedford Northwest'],
  B4C: [44.761, -63.637, 'Lower Sackville South'],
  B4E: [44.816, -63.739, 'Lower Sackville West'],
  B4G: [44.881, -63.680, 'Lower Sackville North'],
  B4H: [45.834, -64.199, 'Amherst'],
  B4N: [45.083, -64.499, 'Kentville'],
  B4P: [45.083, -64.365, 'Wolfville'],
  B4R: [45.067, -64.582, 'Coldbrook'],
  B4V: [44.383, -64.516, 'Bridgewater'],
  B5A: [43.834, -66.116, 'Yarmouth'],
  B6L: [45.409, -63.211, 'Truro'],
  B9A: [45.617, -61.349, 'Port Hawkesbury'],
  C0A: [46.167, -62.649, 'Kings and Queens counties (Elmira)'],
  C0B: [46.602, -63.958, 'Prince County (Portage)'],
  C1A: [46.272, -63.017, 'Charlottetown Southeast Prince Edward Island Provincial Government'],
  C1B: [46.218, -63.080, 'Stratford'],
  C1C: [46.264, -63.084, 'Charlottetown North'],
  C1E: [46.345, -63.201, 'Charlottetown West'],
  C1N: [46.396, -63.788, 'Summerside'],
  E1A: [46.097, -64.709, 'Dieppe Moncton East'],
  E1B: [46.054, -64.816, 'Riverview'],
  E1C: [46.099, -64.804, 'Moncton Central'],
  E1E: [46.077, -64.853, 'Moncton West'],
  E1G: [46.180, -64.948, 'Moncton Northwest'],
  E1H: [46.173, -64.696, 'Lakeville, Shediac Bridge'],
  E1J: [45.998, -64.848, 'Coverdale'],
  E1N: [46.950, -65.324, 'Miramichi South'],
  E1V: [47.194, -65.938, 'Miramichi North'],
  E1W: [47.794, -64.939, 'Caraquet'],
  E1X: [47.514, -64.918, 'Tracadie-Sheila'],
  E2A: [47.618, -65.651, 'Bathurst'],
  E2E: [45.414, -65.982, 'Rothesay, Quispamsis'],
  E2G: [45.453, -65.931, 'Quispamsis'],
  E2H: [45.350, -66.010, 'Saint John Northeast, Renforth'],
  E2J: [45.256, -65.943, 'Saint John East'],
  E2K: [45.305, -66.081, 'Saint John North'],
  E2L: [45.272, -66.058, 'Saint John Central'],
  E2M: [45.235, -66.175, 'Saint John West'],
  E2N: [45.318, -65.927, 'Saint John Lakewood'],
  E2P: [45.243, -65.985, 'Saint John Red Head'],
  E2R: [46.037, -66.037, 'Saint John Grandview'],
  E2S: [45.337, -65.813, 'Saint John Loch Lomond'],
  E2V: [45.835, -66.479, 'Oromocto'],
  E3A: [46.040, -66.386, 'Fredericton North'],
  E3B: [45.812, -66.676, 'Fredericton South New Brunswick Provincial Government'],
  E3C: [45.902, -66.706, 'Fredericton Southwest, New Maryland'],
  E3E: [45.883, -66.916, 'Kingsclear'],
  E3G: [46.055, -66.734, 'Fredericton'],
  E3L: [45.180, -67.295, 'St. Stephen'],
  E3N: [48.008, -66.673, 'Campbellton'],
  E3V: [47.374, -68.325, 'Edmundston'],
  E3Y: [47.168, -67.621, 'Grand Falls Northeast'],
  E3Z: [46.927, -67.747, 'Grand Falls Central'],
  E4A: [46.160, -65.810, 'Bathurst'],
  E4B: [46.085, -66.062, 'Minto'],
  E4C: [45.869, -65.901, 'Youngs Cove'],
  E4E: [45.723, -65.507, 'Sussex'],
  E4G: [45.855, -65.480, 'Smiths Creek'],
  E4H: [45.920, -64.655, 'Hillsborough'],
  E4J: [46.039, -65.046, 'Salisbury'],
  E4K: [45.902, -64.508, 'Dorchester'],
  E4L: [45.919, -64.385, 'Sackville'],
  E4M: [46.092, -64.017, 'Bayfield'],
  E4N: [46.213, -64.278, 'Cap-Pelé'],
  E4P: [46.220, -64.541, 'Shediac'],
  E4R: [46.332, -64.619, 'Cocagne'],
  E4S: [46.468, -64.739, 'Bouctouche'],
  E4T: [46.304, -64.972, 'Bass River'],
  E4V: [46.363, -64.750, 'Saint-Antoine'],
  E4W: [46.681, -64.880, 'Richibucto'],
  E4X: [46.740, -64.970, 'St-Louis-de-Kent'],
  E4Y: [46.734, -65.427, 'Rogersville'],
  E4Z: [45.939, -65.180, 'Petitcodiac'],
  E5A: [45.370, -67.174, 'Moores Mills'],
  E5B: [45.084, -67.062, 'St. Andrews'],
  E5C: [45.127, -66.831, 'St. George'],
  E5E: [44.891, -66.932, 'Campobello Island'],
  E5G: [44.698, -66.806, 'Grand Manan Island'],
  E5H: [45.117, -66.682, 'Pennfield'],
  E5J: [45.198, -66.431, 'Lepreau'],
  E5K: [45.341, -66.253, 'Grand Bay-Westfield'],
  E5L: [45.660, -66.614, 'Fredericton Junction'],
  E5M: [45.770, -66.162, 'Gagetown'],
  E5N: [45.529, -65.853, 'Hampton'],
  E5P: [45.760, -65.670, 'Apohaqui'],
  E5R: [45.351, -65.546, 'St. Martins'],
  E5S: [45.410, -66.093, 'Kingston'],
  E5T: [45.651, -65.730, 'Norton'],
  E5V: [44.986, -66.969, 'Deer Island'],
  E6A: [46.456, -66.420, 'Boiestown'],
  E6B: [46.338, -66.906, 'Stanley'],
  E6C: [46.117, -66.599, 'Durham Bridge'],
  E6E: [46.131, -67.196, 'Millville'],
  E6G: [45.997, -67.240, 'Nackawic'],
  E6H: [45.895, -67.468, 'Canterbury'],
  E6J: [45.592, -67.307, 'McAdam'],
  E6K: [45.729, -67.006, 'Harvey'],
  E6L: [45.988, -67.034, 'Burtts Corner'],
  E7A: [47.300, -68.749, 'Baker Brook'],
  E7B: [47.566, -68.313, 'Saint-Jacques'],
  E7C: [47.658, -68.068, 'Saint-Basile'],
  E7E: [47.173, -67.925, 'Saint-Leonard'],
  E7G: [46.907, -67.390, 'Plaster Rock'],
  E7H: [46.736, -67.704, 'Perth-Andover'],
  E7J: [46.581, -67.591, 'Bath'],
  E7K: [46.398, -67.717, 'Centreville'],
  E7L: [46.553, -67.305, 'Florenceville'],
  E7M: [46.158, -67.584, 'Woodstock'],
  E7N: [46.056, -67.584, 'Debec'],
  E7P: [46.300, -67.517, 'Hartland'],
  E8A: [47.513, -67.393, 'Saint-Quentin'],
  E8B: [47.645, -67.343, 'Kedgwick'],
  E8C: [48.055, -66.385, 'Dalhousie'],
  E8E: [47.679, -66.434, 'Balmoral'],
  E8G: [47.802, -66.124, 'Belledune'],
  E8J: [47.794, -65.822, 'Petit-Rocher'],
  E8K: [47.691, -65.699, 'Beresford'],
  E8L: [47.475, -65.495, 'Allardville'],
  E8M: [47.577, -65.138, 'Saint-Isidore'],
  E8N: [47.808, -65.195, 'Grande-Anse'],
  E8P: [47.667, -64.825, 'Inkerman'],
  E8R: [47.638, -65.171, 'Paquetville'],
  E8S: [47.729, -64.725, 'Shippagan'],
  E8T: [47.794, -64.647, 'Lamèque'],
  E9A: [47.019, -64.920, 'Baie-Sainte-Anne'],
  E9B: [46.740, -65.832, 'Blackville'],
  E9C: [46.557, -66.126, 'Doaktown'],
  E9E: [46.849, -65.677, 'Red Bank'],
  E9G: [47.249, -65.074, 'Neguac'],
  E9H: [47.353, -65.054, 'Brantville'],
  G0A: [47.351, -71.202, 'Capitale-Nationale (Stoneham)'],
  G0B: [47.450, -72.991, 'Cap-aux-Meules'],
  G0C: [48.343, -65.596, 'Gaspésie-Sud (New Richmond)'],
  G0E: [48.918, -65.374, 'Gaspésie-Nord (Grande-Vallée)'],
  G0G: [53.041, -68.688, 'Côte-Nord/Anticosti (Schefferville)'],
  G0H: [49.380, -67.895, 'Manicouagan (Baie-Trinité)'],
  G0J: [48.525, -67.056, 'Gaspésie-Ouest (Causapscal)'],
  G0K: [48.159, -68.195, 'Bas-St-Laurent-Est (Sainte-Luce)'],
  G0L: [47.714, -69.166, 'Bas-St-Laurent-Ouest (Trois-Pistoles)'],
  G0M: [45.972, -70.656, 'Région de Beauce (Saint-Prosper-De-Dorchester)'],
  G0N: [46.099, -71.125, 'Chaudière-Sud (Disraeli)'],
  G0P: [46.012, -71.720, 'Centre-du-Québec-Est (Saint-Valère)'],
  G0R: [46.798, -70.329, 'Appalaches (La Pocatière)'],
  G0S: [46.453, -71.440, 'Chaudière-Nord (Saint-Joseph-De-Beauce)'],
  G0T: [49.014, -69.623, 'Le Fjord (Forestville)'],
  G0V: [50.172, -70.628, 'Saguenay-Lac-St-Jean (Alouette)'],
  G0W: [49.834, -72.262, 'Région de Mistassini (Chambord)'],
  G0X: [47.917, -74.616, 'Mauricie (Parent)'],
  G0Y: [45.624, -71.019, 'L\'Erable (Nantes)'],
  G0Z: [46.179, -72.157, 'Centre-du-Québec-Nord (Daveluyville)'],
  G1A: [46.859, -71.192, 'Quebec Provincial Government'],
  G1B: [46.926, -71.226, 'Beauport North'],
  G1C: [46.880, -71.196, 'Beauport Central'],
  G1E: [46.859, -71.192, 'Beauport South'],
  G1G: [46.877, -71.284, 'Jean-Talon Southeast'],
  G1H: [46.853, -71.257, 'Charlesbourg South'],
  G1J: [46.838, -71.223, 'Quebec City Lower Riverbank'],
  G1K: [46.814, -71.219, 'Quebec City Mid-Riverbank'],
  G1L: [46.830, -71.246, 'Quebec City Northeast'],
  G1M: [46.818, -71.271, 'Quebec City North Central'],
  G1N: [46.803, -71.264, 'Quebec City South Central'],
  G1P: [46.810, -71.310, 'Quebec City West'],
  G1R: [46.807, -71.218, 'Quebec City East'],
  G1S: [46.793, -71.245, 'Quebec City South'],
  G1T: [46.774, -71.261, 'Quebec City Upper Riverbank'],
  G1V: [46.782, -71.288, 'Sainte-Foy Northeast'],
  G1W: [46.759, -71.298, 'Sainte-Foy Southeast'],
  G1X: [46.775, -71.334, 'Sainte-Foy West'],
  G1Y: [46.751, -71.356, 'Cap-Rouge'],
  G2A: [46.875, -71.392, 'Loretteville North'],
  G2B: [46.850, -71.336, 'Loretteville South'],
  G2C: [46.829, -71.334, 'Quebec City Northwest'],
  G2E: [46.808, -71.361, 'L\'Ancienne-Lorette Northeast'],
  G2G: [46.790, -71.416, 'L\'Ancienne-Lorette Southwest'],
  G2J: [46.840, -71.278, 'Quebec City Inner North'],
  G2K: [46.855, -71.304, 'Quebec City Outer North'],
  G2L: [46.889, -71.254, 'Charlesbourg North'],
  G2M: [46.922, -71.306, 'Jean-Talon Northeast'],
  G2N: [46.914, -71.340, 'Jean-Talon West'],
  G3A: [46.741, -71.451, 'St-Augustin-De-Desmaures'],
  G3B: [46.983, -71.291, 'Lac-Beauport'],
  G3C: [47.169, -71.433, 'Stoneham-et-Tewkesbury'],
  G3E: [46.878, -71.341, 'Saint-Émile'],
  G3G: [46.924, -71.396, 'Lac-Saint-Charles'],
  G3H: [46.755, -71.696, 'Pont-Rouge'],
  G3J: [46.860, -71.475, 'Val-Bélair North'],
  G3K: [46.831, -71.443, 'Val-Bélair South'],
  G3L: [47.237, -71.876, 'Saint-Raymond'],
  G3M: [46.680, -71.724, 'Donnacona'],
  G3N: [46.852, -71.621, 'Sainte-Catherine-de-la-Jacques-Cartier'],
  G3S: [46.880, -71.515, 'Shannon'],
  G3Z: [47.441, -70.499, 'Baie-Saint-Paul'],
  G4A: [47.718, -70.228, 'Clermont'],
  G4R: [50.856, -67.051, 'Sept-Îles Southeast'],
  G4S: [50.271, -66.375, 'Sept-Îles Northwest'],
  G4T: [47.400, -61.800, 'Les Îles-De-La-Madeleine'],
  G4V: [48.971, -66.308, 'Sainte-Anne-Des-Monts'],
  G4W: [48.829, -67.522, 'Matane'],
  G4X: [48.833, -64.482, 'Gaspé'],
  G4Z: [51.087, -68.632, 'Baie-Comeau Northeast'],
  G5A: [47.657, -70.156, 'La Malbaie'],
  G5B: [50.033, -66.865, 'Port-Cartier'],
  G5C: [50.347, -69.041, 'Baie-Comeau Southwest'],
  G5H: [48.584, -68.192, 'Mont-Joli'],
  G5J: [48.464, -67.431, 'Amqui'],
  G5L: [48.416, -68.598, 'Rimouski Central'],
  G5M: [48.497, -68.458, 'Rimouski Northeast'],
  G5N: [48.367, -68.466, 'Rimouski Southwest'],
  G5R: [47.830, -69.534, 'Rivière-du-Loup'],
  G5T: [47.547, -68.643, 'Degelis'],
  G5V: [46.980, -70.555, 'Montmagny'],
  G5X: [46.218, -70.779, 'Beauceville'],
  G5Y: [46.133, -70.638, 'Saint-Georges Central'],
  G5Z: [46.064, -70.712, 'Saint-Georges Southeast'],
  G6A: [46.144, -70.682, 'Saint-Georges Northwest'],
  G6B: [45.583, -70.882, 'Lac-Megantic'],
  G6C: [46.770, -71.091, 'Pintendre'],
  G6E: [46.434, -71.012, 'Sainte-Marie'],
  G6G: [46.094, -71.305, 'Thetford Mines'],
  G6H: [46.070, -71.439, 'Black Lake'],
  G6J: [46.636, -71.310, 'Saint-Etienne-De-Lauzon'],
  G6K: [46.688, -71.303, 'Saint-Redempteur'],
  G6L: [46.219, -71.762, 'Plessisville'],
  G6P: [46.053, -71.948, 'Victoriaville Central'],
  G6R: [46.016, -71.956, 'Victoriaville South'],
  G6S: [46.026, -71.872, 'Victoriaville East'],
  G6T: [46.083, -71.973, 'Victoriaville Northwest'],
  G6V: [46.803, -71.178, 'Lévis North'],
  G6W: [46.755, -71.220, 'Lévis South'],
  G6X: [46.715, -71.261, 'Charny'],
  G6Y: [46.803, -71.178, 'Lévis'],
  G6Z: [46.690, -71.185, 'Saint-Jean-Chrysostome'],
  G7A: [46.684, -71.383, 'Saint-Nicolas'],
  G7B: [48.340, -70.889, 'La Baie'],
  G7G: [48.445, -71.103, 'Chicoutimi North'],
  G7H: [48.419, -71.042, 'Chicoutimi East'],
  G7J: [48.417, -71.103, 'Chicoutimi West'],
  G7K: [48.369, -71.118, 'Chicoutimi Southwest'],
  G7N: [48.201, -71.143, 'Laterrière'],
  G7P: [48.550, -71.316, 'Saint-Ambroise'],
  G7S: [48.429, -71.177, 'Jonquière Northeast'],
  G7T: [48.398, -71.153, 'Jonquière Southeast'],
  G7X: [48.320, -71.415, 'Jonquière Central'],
  G7Y: [48.370, -71.236, 'Jonquière Southwest'],
  G7Z: [48.438, -71.264, 'Jonquière Northwest'],
  G8A: [48.423, -71.363, 'Jonquière West'],
  G8B: [48.555, -71.673, 'Alma Southeast'],
  G8C: [48.528, -71.636, 'Alma Southwest'],
  G8E: [48.638, -71.696, 'Alma North'],
  G8G: [47.808, -71.591, 'Métabetchouan-Lac-a-la-Croix'],
  G8H: [48.517, -72.232, 'Roberval'],
  G8J: [48.583, -72.332, 'Saint-Prime'],
  G8K: [48.650, -72.449, 'Saint-Félicien'],
  G8L: [48.876, -72.212, 'Dolbeau-Mistassini'],
  G8M: [48.883, -72.449, 'Albanel'],
  G8N: [48.347, -71.679, 'Hébertville'],
  G8P: [49.917, -74.366, 'Chibougamau'],
  G8T: [46.388, -72.536, 'Cap-de-la-Madeleine Central and southeast'],
  G8V: [46.410, -72.491, 'Cap-de-la-Madeleine Northeast'],
  G8W: [46.418, -72.637, 'Cap-de-la-Madeleine West'],
  G8Y: [46.367, -72.617, 'Trois-Rivières Central'],
  G8Z: [46.346, -72.572, 'Trois-Rivières Northeast'],
  G9A: [46.370, -72.679, 'Trois-Rivières East'],
  G9B: [46.316, -72.683, 'Trois-Rivières South'],
  G9C: [46.392, -72.672, 'Trois-Rivières West'],
  G9H: [46.333, -72.432, 'Becancour'],
  G9N: [46.556, -72.720, 'Shawinigan Central'],
  G9P: [46.507, -72.744, 'Shawinigan Southeast'],
  G9R: [46.610, -72.827, 'Shawinigan Northwest'],
  G9T: [46.632, -72.737, 'Grand-Mère'],
  G9X: [47.433, -72.782, 'La Tuque'],
  H0H: [90.000, 0.000, 'Reserved (Santa Claus)'],
  H0M: [45.699, -73.502, 'Akwesasne Region (Akwesasne)'],
  H1A: [45.675, -73.502, 'Pointe-Aux-Trembles'],
  H1B: [45.632, -73.507, 'Montreal East'],
  H1C: [45.666, -73.537, 'Rivière-des-Prairies Northeast'],
  H1E: [45.634, -73.584, 'Rivière-Des-Prairies Southwest'],
  H1G: [45.611, -73.621, 'Montreal North North'],
  H1H: [45.590, -73.639, 'Montreal North South'],
  H1J: [45.610, -73.579, 'Anjou West'],
  H1K: [45.610, -73.547, 'Anjou East'],
  H1L: [45.604, -73.518, 'Mercier North'],
  H1M: [45.588, -73.557, 'Mercier West'],
  H1N: [45.578, -73.530, 'Mercier Southeast'],
  H1P: [45.597, -73.593, 'Saint-Léonard North'],
  H1R: [45.586, -73.608, 'Saint-Léonard West'],
  H1S: [45.581, -73.582, 'Saint-Léonard Southeast'],
  H1T: [45.573, -73.570, 'Rosemont North'],
  H1V: [45.559, -73.539, 'Maisonneuve'],
  H1W: [45.544, -73.547, 'Hochelaga'],
  H1X: [45.558, -73.570, 'Rosemont Central'],
  H1Y: [45.549, -73.579, 'Rosemont South'],
  H1Z: [45.569, -73.622, 'Saint-Michel West'],
  H2A: [45.562, -73.599, 'Saint-Michel East'],
  H2B: [45.574, -73.651, 'Ahuntsic North'],
  H2C: [45.561, -73.658, 'Ahuntsic Central'],
  H2E: [45.551, -73.612, 'Villeray Northeast'],
  H2G: [45.544, -73.593, 'Petite-Patrie Northeast'],
  H2H: [45.537, -73.573, 'Plateau Mont-Royal North'],
  H2J: [45.530, -73.583, 'Plateau Mont-Royal North Central'],
  H2K: [45.531, -73.555, 'Centre-Sud North'],
  H2L: [45.519, -73.555, 'Centre-Sud South'],
  H2M: [45.553, -73.641, 'Ahuntsic East'],
  H2N: [45.539, -73.651, 'Ahuntsic Southeast'],
  H2P: [45.544, -73.634, 'Villeray West'],
  H2R: [45.540, -73.623, 'Villeray Southeast'],
  H2S: [45.535, -73.606, 'Petite-Patrie Southwest'],
  H2T: [45.525, -73.595, 'Plateau Mont-Royal West'],
  H2V: [45.517, -73.607, 'Outremont'],
  H2W: [45.518, -73.580, 'Plateau Mont-Royal South Central'],
  H2X: [45.511, -73.568, 'Plateau Mont-Royal Southeast'],
  H2Y: [45.506, -73.555, 'Old Montreal'],
  H2Z: [45.505, -73.562, 'Downtown Montreal Northeast'],
  H3A: [45.504, -73.575, 'Downtown Montreal North'],
  H3B: [45.501, -73.568, 'Downtown Montreal East'],
  H3C: [45.498, -73.547, 'Griffintown (Includes Île Notre-Dame & Île Sainte-Hélène)'],
  H3E: [45.459, -73.550, 'L\'Île-Des-Soeurs'],
  H3G: [45.499, -73.579, 'Downtown Montreal Southeast'],
  H3H: [45.501, -73.588, 'Downtown Montreal South & West'],
  H3J: [45.486, -73.573, 'Petite-Bourgogne'],
  H3K: [45.480, -73.555, 'Pointe-Saint-Charles'],
  H3L: [45.547, -73.672, 'Ahuntsic Southwest'],
  H3M: [45.538, -73.693, 'Cartierville Northeast'],
  H3N: [45.530, -73.633, 'Parc-Extension'],
  H3P: [45.522, -73.639, 'Mount Royal North'],
  H3R: [45.510, -73.648, 'Mount Royal Central'],
  H3S: [45.506, -73.630, 'Côte-des-Neiges North'],
  H3T: [45.502, -73.619, 'Côte-des-Neiges Northeast'],
  H3V: [45.499, -73.609, 'Côte-des-Neiges East'],
  H3W: [45.490, -73.631, 'Côte-des-Neiges Southwest'],
  H3X: [45.482, -73.642, 'Hampstead'],
  H3Y: [45.488, -73.605, 'Westmount West'],
  H3Z: [45.483, -73.593, 'Westmount East'],
  H4A: [45.472, -73.615, 'Notre-Dame-de-Grâce Northeast'],
  H4B: [45.460, -73.630, 'Notre-Dame-de-Grâce Southwest'],
  H4C: [45.474, -73.588, 'Saint-Henri'],
  H4E: [45.455, -73.599, 'Ville Émard'],
  H4G: [45.464, -73.570, 'Verdun North'],
  H4H: [45.446, -73.582, 'Verdun South'],
  H4J: [45.531, -73.709, 'Cartierville Central'],
  H4K: [45.517, -73.736, 'Cartierville Southwest'],
  H4L: [45.517, -73.683, 'Saint-Laurent Inner Northeast'],
  H4M: [45.498, -73.689, 'Saint-Laurent East'],
  H4N: [45.526, -73.665, 'Saint-Laurent Outer Northeast'],
  H4P: [45.496, -73.665, 'Mount Royal South'],
  H4R: [45.505, -73.714, 'Saint-Laurent Central'],
  H4S: [45.486, -73.743, 'Saint-Laurent Southwest'],
  H4T: [45.475, -73.696, 'Saint-Laurent Southeast'],
  H4V: [45.467, -73.649, 'Côte-Saint-Luc East'],
  H4W: [45.470, -73.669, 'Côte-Saint-Luc West'],
  H4X: [45.453, -73.649, 'Montreal West'],
  H4Y: [45.865, -72.761, 'Dorval Central'],
  H4Z: [45.506, -73.557, 'Tour de la Bourse'],
  H5A: [45.499, -73.565, 'Place Bonaventure'],
  H5B: [45.507, -73.562, 'Place Desjardins'],
  H7A: [45.674, -73.592, 'Duvernay-Est'],
  H7B: [45.676, -73.639, 'Saint-Franþois'],
  H7C: [45.617, -73.649, 'Saint-Vincent-de-Paul'],
  H7E: [45.623, -73.695, 'Duvernay'],
  H7G: [45.577, -73.687, 'Pont-Viau'],
  H7H: [45.641, -73.754, 'Auteuil West'],
  H7J: [45.663, -73.700, 'Auteuil Northeast'],
  H7K: [45.621, -73.740, 'Auteuil South'],
  H7L: [45.617, -73.782, 'Sainte-Rose'],
  H7M: [45.598, -73.716, 'Vimont'],
  H7N: [45.550, -73.699, 'Laval-des-Rapides'],
  H7P: [45.578, -73.800, 'Fabreville'],
  H7R: [45.553, -73.851, 'Laval-sur-le-Lac'],
  H7S: [45.579, -73.737, 'Chomedey Northeast'],
  H7T: [45.557, -73.772, 'Chomedey Northwest'],
  H7V: [45.548, -73.737, 'Chomedey East'],
  H7W: [45.534, -73.765, 'Chomedey South'],
  H7X: [45.533, -73.816, 'Sainte-Dorothée'],
  H7Y: [45.528, -73.851, 'Îles-Laval'],
  H8N: [45.438, -73.621, 'LaSalle Northwest'],
  H8P: [45.401, -73.619, 'LaSalle Southeast'],
  H8R: [45.399, -73.651, 'Saint-Pierre'],
  H8S: [45.440, -73.675, 'Lachine East'],
  H8T: [45.442, -73.706, 'Lachine West'],
  H8Y: [45.508, -73.808, 'Roxboro'],
  H8Z: [45.507, -73.841, 'Pierrefonds'],
  H9A: [45.495, -73.832, 'Dollard-Des-Ormeaux Northwest'],
  H9B: [45.490, -73.796, 'Dollard-Des-Ormeaux East'],
  H9C: [45.505, -73.879, 'L\'Île Bizard Northeast'],
  H9E: [45.486, -73.909, 'L\'Île-Bizard Southwest'],
  H9G: [45.476, -73.837, 'Dollard-Des-Ormeaux Southwest'],
  H9H: [45.468, -73.856, 'Sainte-Geneviève'],
  H9J: [45.450, -73.866, 'Kirkland'],
  H9K: [45.458, -73.916, 'Senneville'],
  H9P: [45.468, -73.775, 'Dorval Outskirts'],
  H9R: [45.449, -73.817, 'Pointe-Claire'],
  H9S: [45.441, -73.775, 'L\'Île-Dorval'],
  H9W: [45.433, -73.866, 'Beaconsfield'],
  H9X: [45.406, -73.946, 'Sainte-Anne-De-Bellevue'],
  J0A: [45.838, -71.954, 'Centre-du-Québec-Sud (Warwick)'],
  J0B: [45.100, -72.049, 'Estrie-Est (Stanstead)'],
  J0C: [45.857, -72.697, 'Centre-du-Québec-Ouest (Saint-Bonaventure)'],
  J0E: [45.283, -72.524, 'Estrie-Ouest (Fulford)'],
  J0G: [46.021, -72.824, 'Bois-Francs-Nord (Odanak)'],
  J0H: [45.661, -72.770, 'Bois-Francs-Sud (Saint-Nazaire-D\'Acton)'],
  J0J: [45.153, -73.164, 'Montérégie-Est (Bedford)'],
  J0K: [46.797, -73.871, 'Lanaudière-Nord (Saint-Esprit)'],
  J0L: [45.196, -73.570, 'Montérégie-Nord (Saint-Antoine-Sur-Richelieu)'],
  J0M: [58.327, -72.164, 'Nunavik (Kuujjuaq)'],
  J0N: [45.514, -74.053, 'Région d\'Oka (Oka)'],
  J0P: [45.365, -74.312, 'Vaudreuil-Soulanges (Coteau-du-Lac)'],
  J0R: [45.866, -74.178, 'Lanaudière-Sud (Prévost)'],
  J0S: [45.108, -74.045, 'Montérégie-Ouest (Saint-Anicet)'],
  J0T: [46.300, -74.585, 'Laurentides-Nord (Montcalm)'],
  J0V: [45.827, -74.932, 'Laurentides-Sud (Chénéville)'],
  J0W: [47.092, -75.797, 'Outaouais-Nord (Ferme-Neuve)'],
  J0X: [46.307, -76.765, 'Outaouais-Sud (Thurso)'],
  J0Y: [52.105, -75.281, 'Abitibi-Témiscamingue-Est (Radisson)'],
  J0Z: [47.863, -78.824, 'Abitibi-Témiscamingue-Ouest (Guigues)'],
  J1A: [45.133, -71.799, 'Coaticook'],
  J1C: [45.480, -71.949, 'Bromptonville'],
  J1E: [45.423, -71.872, 'Sherbrooke Northeast'],
  J1G: [45.402, -71.848, 'Sherbrooke East'],
  J1H: [45.389, -71.899, 'Sherbrooke Central'],
  J1J: [45.413, -71.924, 'Sherbrooke North'],
  J1K: [45.382, -71.933, 'Sherbrooke West'],
  J1L: [45.411, -71.959, 'Sherbrooke Northwest'],
  J1M: [45.366, -71.842, 'Sherbrooke Southeast'],
  J1N: [45.340, -72.013, 'Rock Forest'],
  J1R: [45.397, -72.042, 'Saint-Élie-d\'Orford'],
  J1S: [45.567, -71.999, 'Windsor'],
  J1T: [45.767, -71.932, 'Asbestos'],
  J1X: [45.267, -72.149, 'Magog'],
  J1Z: [45.933, -72.432, 'Saint-Cyrille-De-Wendover'],
  J2A: [45.815, -72.403, 'Drummondville Southeast'],
  J2B: [45.906, -72.593, 'Drummondville South'],
  J2C: [45.889, -72.505, 'Drummondville Central'],
  J2E: [45.910, -72.529, 'Drummondville Northwest'],
  J2G: [45.405, -72.720, 'Granby Central'],
  J2H: [45.394, -72.701, 'Granby East'],
  J2J: [45.401, -72.782, 'Granby West'],
  J2K: [45.200, -72.749, 'Cowansville'],
  J2L: [45.317, -72.649, 'Bromont'],
  J2M: [45.350, -72.566, 'Shefford'],
  J2N: [45.283, -72.982, 'Farnham'],
  J2R: [45.657, -72.924, 'Saint-Hyacinthe Northwest'],
  J2S: [45.614, -72.991, 'Saint-Hyacinthe Southwest'],
  J2T: [45.597, -72.937, 'Saint-Hyacinthe East'],
  J2W: [45.369, -73.314, 'Saint-Luc'],
  J2X: [45.309, -73.219, 'Saint-Jean-sur-Richelieu East'],
  J2Y: [45.311, -73.356, 'Saint-Jean-sur-Richelieu West'],
  J3A: [45.334, -73.274, 'Saint-Jean-sur-Richelieu North'],
  J3B: [45.283, -73.279, 'Saint-Jean-sur-Richelieu Central'],
  J3E: [45.583, -73.332, 'Sainte-Julie'],
  J3G: [45.595, -73.228, 'Beloeil West'],
  J3H: [45.553, -73.175, 'Beloeil East'],
  J3L: [45.450, -73.282, 'Chambly'],
  J3M: [45.433, -73.166, 'Marieville'],
  J3N: [45.533, -73.282, 'Saint-Basile-Le-Grand'],
  J3P: [46.036, -73.067, 'Sorel Central'],
  J3R: [46.021, -73.144, 'Sorel Southwest'],
  J3T: [46.217, -72.616, 'Nicolet'],
  J3V: [45.532, -73.344, 'Saint-Bruno'],
  J3X: [45.683, -73.433, 'Varennes'],
  J3Y: [45.491, -73.399, 'Saint-Hubert Central'],
  J3Z: [45.498, -73.401, 'Saint-Hubert East'],
  J4B: [45.591, -73.436, 'Boucherville'],
  J4G: [45.568, -73.476, 'Longueuil North'],
  J4H: [45.537, -73.506, 'Longueuil West'],
  J4J: [45.536, -73.472, 'Longueuil Central'],
  J4K: [45.518, -73.502, 'Longueuil Southwest'],
  J4L: [45.518, -73.458, 'Longueuil Southeast'],
  J4M: [45.542, -73.438, 'Longueuil East'],
  J4N: [45.552, -73.456, 'Longueuil Northeast'],
  J4P: [45.507, -73.508, 'Saint-Lambert North'],
  J4R: [45.492, -73.501, 'Saint-Lambert Central'],
  J4S: [45.481, -73.497, 'Saint-Lambert South'],
  J4T: [45.497, -73.468, 'Saint-Hubert West'],
  J4V: [45.486, -73.462, 'Greenfield Park'],
  J4W: [45.467, -73.483, 'Brossard Northwest'],
  J4X: [45.446, -73.484, 'Brossard Southwest'],
  J4Y: [45.441, -73.456, 'Brossard South'],
  J4Z: [45.442, -73.423, 'Brossard Northeast'],
  J5A: [45.367, -73.566, 'Saint-Constant'],
  J5B: [45.367, -73.549, 'Delson'],
  J5C: [45.400, -73.582, 'Sainte-Catherine'],
  J5J: [45.831, -73.919, 'Saint-Sophie'],
  J5K: [45.733, -74.132, 'Saint-Colomban'],
  J5L: [45.799, -74.073, 'Saint-Jérôme West'],
  J5M: [45.850, -73.766, 'Saint-Lin-Laurentides'],
  J5R: [45.417, -73.499, 'La Prairie'],
  J5T: [45.883, -73.282, 'Lavaltrie'],
  J5V: [46.256, -72.942, 'Louiseville'],
  J5W: [45.823, -73.429, 'L\'Assomption'],
  J5X: [45.850, -73.483, 'L\'Épiphanie'],
  J5Y: [45.777, -73.425, 'Repentigny Northeast'],
  J5Z: [45.764, -73.504, 'Repentigny West'],
  J6A: [45.739, -73.459, 'Repentigny South'],
  J6E: [46.017, -73.449, 'Joliette'],
  J6J: [45.369, -73.722, 'Châteauguay North'],
  J6K: [45.353, -73.731, 'Châteauguay South'],
  J6N: [45.317, -73.866, 'Beauharnois'],
  J6R: [45.317, -73.749, 'Mercier'],
  J6S: [45.270, -74.048, 'Salaberry-de-Valleyfield North'],
  J6T: [45.241, -74.110, 'Salaberry-de-Valleyfield South'],
  J6V: [45.714, -73.536, 'Terrebonne East'],
  J6W: [45.706, -73.618, 'Terrebonne Central'],
  J6X: [45.727, -73.706, 'Terrebonne Northwest'],
  J6Y: [45.700, -73.752, 'Terrebonne Southwest'],
  J6Z: [45.669, -73.775, 'Sainte-Thérèse-de-Blainville Northeast'],
  J7A: [45.638, -73.797, 'Sainte-Thérèse-de-Blainville East'],
  J7B: [45.660, -73.816, 'Sainte-Thérèse-de-Blainville North'],
  J7C: [45.689, -73.867, 'Sainte-Thérèse-de-Blainville Northwest'],
  J7E: [45.644, -73.845, 'Sainte-Thérèse-de-Blainville Central'],
  J7G: [45.609, -73.838, 'Sainte-Thérèse-de-Blainville South'],
  J7H: [45.621, -73.873, 'Sainte-Thérèse-de-Blainville Southwest'],
  J7J: [45.705, -73.947, 'Mirabel Northeast'],
  J7K: [45.770, -73.605, 'Mascouche Extremities'],
  J7L: [45.742, -73.651, 'Mascouche Central'],
  J7M: [45.789, -73.744, 'La Plaine'],
  J7N: [45.635, -74.100, 'Mirabel Southwest'],
  J7P: [45.578, -73.881, 'Saint-Eustache Northeast'],
  J7R: [45.574, -73.940, 'Saint-Eustache Southwest'],
  J7T: [45.370, -74.125, 'Vaudreuil-Dorion RCM'],
  J7V: [45.400, -74.032, 'Vaudreuil-Dorion'],
  J7W: [45.367, -73.974, 'Pincourt'],
  J7X: [45.269, -74.234, 'Valleyfield'],
  J7Y: [45.806, -74.016, 'Saint-Jérôme North'],
  J7Z: [45.779, -73.983, 'Saint-Jérôme Southeast'],
  J8A: [45.933, -74.016, 'Saint-Hippolyte'],
  J8B: [45.950, -74.132, 'Sainte-Adèle'],
  J8C: [46.050, -74.282, 'Sainte-Agathe-Des-Monts'],
  J8E: [46.195, -74.626, 'Mont-Tremblant'],
  J8G: [45.683, -74.416, 'Chatham'],
  J8H: [45.650, -74.332, 'Lachute'],
  J8L: [45.586, -75.421, 'Buckingham'],
  J8M: [45.544, -75.427, 'Masson-Angers'],
  J8N: [45.650, -75.666, 'Val-des-Monts'],
  J8P: [45.487, -75.616, 'Gatineau Southeast'],
  J8R: [45.529, -75.609, 'Gatineau Northeast'],
  J8T: [45.478, -75.706, 'Gatineau Southwest'],
  J8V: [45.571, -75.761, 'Gatineau Northwest'],
  J8X: [45.440, -75.712, 'Hull Southeast'],
  J8Y: [45.448, -75.743, 'Hull Central'],
  J8Z: [45.472, -75.762, 'Hull North'],
  J9A: [45.428, -75.771, 'Hull Southwest'],
  J9B: [45.500, -75.783, 'Chelsea'],
  J9E: [46.383, -75.966, 'Maniwaki'],
  J9H: [45.393, -75.829, 'Aylmer South'],
  J9J: [45.439, -75.847, 'Aylmer North'],
  J9L: [46.550, -75.499, 'Mont-Laurier'],
  J9P: [48.100, -77.783, 'Val-d\'Or'],
  J9T: [48.567, -78.116, 'Amos'],
  J9V: [47.333, -79.433, 'Ville-Marie'],
  J9X: [48.285, -78.823, 'Rouyn-Noranda South'],
  J9Y: [48.161, -79.071, 'Rouyn-Noranda North'],
  J9Z: [48.800, -79.200, 'La Sarre'],
  K0A: [45.256, -76.275, 'National Capital Region (Almonte)'],
  K0B: [45.503, -74.748, 'Prescott and Russell United Counties (Alfred)'],
  K0C: [45.169, -74.897, 'Stormont, Dundas and Glengarry United Counties (Alexandria)'],
  K0E: [44.873, -75.442, 'South Leeds and Grenville United Counties (Prescott)'],
  K0G: [45.047, -76.476, 'Rideau Lakes area (Kemptville)'],
  K0H: [44.721, -76.833, 'Frontenac County, Addington County, Loyalist Shores and Southwest Leeds (Inverary)'],
  K0J: [45.661, -77.589, 'Renfrew County and Lanark Highlands Township (Deep River)'],
  K0K: [44.326, -77.432, 'Quinte Shores, East Northumberland County & Prince Edward County (Picton)'],
  K0L: [44.777, -77.969, 'Peterborough County and North Hastings County (Lakefield)'],
  K0M: [44.864, -78.655, 'Kawartha lakes and Haliburton County (Bobcaygeon)'],
  K1A: [45.421, -75.702, 'Government of Canada Ottawa and Gatineau offices'],
  K1B: [45.428, -75.588, 'Gloucester (Blackburn Hamlet / Pine View)'],
  K1C: [45.468, -75.540, 'Gloucester (West Orleans)'],
  K1E: [45.477, -75.505, 'Orleans (Queenswood)'],
  K1G: [45.355, -75.577, 'Ottawa (Riverview / Hawthorne)'],
  K1H: [45.388, -75.659, 'Ottawa (Alta Vista)'],
  K1J: [45.452, -75.604, 'Gloucester (Beacon Hill / Cyrville)'],
  K1K: [45.445, -75.643, 'Ottawa (Overbrook)'],
  K1L: [45.440, -75.663, 'Ottawa (Vanier)'],
  K1M: [45.449, -75.682, 'Ottawa (Rockcliffe Park / New Edinburgh)'],
  K1N: [45.429, -75.684, 'Ottawa (Lower Town / Sandy Hill / University of Ottawa)'],
  K1P: [45.422, -75.703, 'Ottawa (Parliament Hill)'],
  K1R: [45.412, -75.711, 'Ottawa (West Downtown area)'],
  K1S: [45.399, -75.687, 'Ottawa (The Glebe / Ottawa South / Ottawa East)'],
  K1T: [45.330, -75.616, 'Gloucester (Blossom Park / Hunt Club East / Leitrim)'],
  K1V: [45.328, -75.672, 'Ottawa (Riverside Park / Hunt Club West / Riverside South / YOW)'],
  K1W: [45.437, -75.516, 'Gloucester (South Orleans)'],
  K1X: [45.276, -75.628, 'Gloucester South'],
  K1Y: [45.402, -75.733, 'Ottawa West'],
  K1Z: [45.387, -75.740, 'Ottawa (Westboro)'],
  K2A: [45.380, -75.764, 'Ottawa (Highland Park / Carlingwood)'],
  K2B: [45.364, -75.793, 'Ottawa (Britannia / Pinecrest)'],
  K2C: [45.368, -75.738, 'Ottawa (Queensway / Copeland / Carlington / Carleton Heights)'],
  K2E: [45.344, -75.716, 'Nepean East'],
  K2G: [45.321, -75.739, 'Nepean (Davidson Heights)'],
  K2H: [45.343, -75.826, 'Nepean (Bells Corners)'],
  K2J: [45.269, -75.752, 'Nepean (Barrhaven)'],
  K2K: [45.370, -75.920, 'Kanata (Beaverbrook / South March)'],
  K2L: [45.300, -75.924, 'Kanata (Katimavik-Hazeldean / Glen Cairn)'],
  K2M: [45.286, -75.856, 'Kanata (Bridlewood)'],
  K2P: [45.417, -75.690, 'Ottawa (Centre Town)'],
  K2R: [45.290, -75.813, 'Nepean (Fallowfield Village / Cedarhill Estates / Orchard Estates)'],
  K2S: [45.250, -75.916, 'Stittsville'],
  K2T: [45.317, -75.937, 'Kanata (Marchwood)'],
  K2V: [45.285, -75.893, 'Kanata (Terry Fox / Palladium)'],
  K2W: [45.370, -75.989, 'Kanata (North March)'],
  K4A: [45.470, -75.472, 'Orleans (Fallingbrook)'],
  K4B: [45.410, -75.364, 'Cumberland Township'],
  K4C: [45.498, -75.392, 'Cumberland'],
  K4K: [45.550, -75.291, 'Rockland'],
  K4M: [45.215, -75.653, 'Manotick'],
  K4P: [45.243, -75.567, 'Greely'],
  K4R: [45.239, -75.353, 'Russell'],
  K6A: [45.600, -74.616, 'Hawkesbury'],
  K6H: [45.056, -74.685, 'Cornwall East'],
  K6J: [45.022, -74.757, 'Cornwall West'],
  K6K: [45.061, -74.777, 'Cornwall North'],
  K6T: [44.630, -75.745, 'Elizabethtown'],
  K6V: [44.657, -75.715, 'Brockville'],
  K7A: [44.900, -76.016, 'Smiths Falls'],
  K7C: [45.133, -76.149, 'Carleton Place'],
  K7G: [44.333, -76.166, 'Gananoque'],
  K7H: [44.900, -76.249, 'Perth'],
  K7K: [44.257, -76.472, 'Kingston (SW Pittsburgh Township)'],
  K7L: [44.295, -76.428, 'Kingston (Downtown)'],
  K7M: [44.241, -76.579, 'Kingston (Reddendale / Cataraqui / Collins Bay)'],
  K7N: [44.222, -76.650, 'Amherstview'],
  K7P: [44.281, -76.611, 'Kingston (Westbrook / Cataraqui Woods / Cedarwood)'],
  K7R: [44.250, -76.949, 'Napanee'],
  K7S: [45.433, -76.349, 'Arnprior'],
  K7V: [45.467, -76.683, 'Renfrew'],
  K8A: [45.747, -77.205, 'Pembroke Central and northern subdivisions'],
  K8B: [45.808, -77.081, 'Pembroke (Pleasant View / Fairview)'],
  K8H: [45.895, -77.280, 'Petawawa'],
  K8N: [44.173, -77.368, 'Belleville East'],
  K8P: [44.166, -77.404, 'Belleville West'],
  K8R: [44.140, -77.468, 'Belleville (SE Sidney Township / Avondale)'],
  K8V: [44.099, -77.578, 'Trenton'],
  K9A: [43.960, -78.165, 'Cobourg'],
  K9H: [44.325, -78.318, 'Peterborough North'],
  K9J: [44.310, -78.240, 'Peterborough South'],
  K9K: [44.314, -78.361, 'Peterborough (Fairbairn Meadows / Jackson Heights)'],
  K9L: [44.355, -78.320, 'Peterborough (Terra View Heights / Woodland Acres / Donwood)'],
  K9V: [44.350, -78.733, 'Lindsay'],
  L0A: [44.126, -78.519, 'West Northumberland County (Millbrook)'],
  L0B: [44.077, -78.746, 'East Durham Regional Municipality (Orono)'],
  L0C: [44.209, -79.073, 'West Durham Regional Municipality (Sunderland)'],
  L0E: [44.320, -79.278, 'Lake Simcoe Southeast Shore (Sutton West)'],
  L0G: [44.059, -79.624, 'Ontario Centre (Queensville)'],
  L0H: [43.902, -79.155, 'Whitby Region (Gormley)'],
  L0J: [43.857, -79.648, 'North Peel Regional Municipality (Kleinburg)'],
  L0K: [44.623, -79.124, 'Lake Simcoe North Shore (Coldwater)'],
  L0L: [44.455, -79.735, 'Lake Simcoe West Shore (Oro)'],
  L0M: [44.327, -80.033, 'Georgian Bay South Shore (Angus)'],
  L0N: [44.032, -80.207, 'Dufferin County (Shelburne)'],
  L0P: [43.491, -80.000, 'Halton Regional Municipality (Campbellville)'],
  L0R: [43.161, -79.746, 'East Haldimand County (Waterdown)'],
  L0S: [42.907, -79.083, 'Niagara Regional Municipality (Fonthill)'],
  L1A: [44.017, -78.400, 'Port Hope'],
  L1B: [43.923, -78.546, 'Bowmanville East'],
  L1C: [43.971, -78.710, 'Bowmanville West'],
  L1E: [43.897, -78.768, 'Courtice'],
  L1G: [43.923, -78.868, 'Oshawa Central'],
  L1H: [43.972, -78.884, 'Oshawa Southeast'],
  L1J: [43.885, -78.877, 'Oshawa Southwest'],
  L1K: [43.925, -78.829, 'Oshawa East'],
  L1L: [43.958, -78.897, 'Oshawa North'],
  L1M: [43.957, -78.978, 'Whitby North'],
  L1N: [43.872, -78.927, 'Whitby Southeast'],
  L1P: [43.887, -78.975, 'Whitby Southwest'],
  L1R: [43.922, -78.941, 'Whitby Central'],
  L1S: [43.840, -79.025, 'Ajax Southwest'],
  L1T: [43.884, -79.053, 'Ajax Northwest'],
  L1V: [43.861, -79.162, 'Pickering Southwest'],
  L1W: [43.820, -79.080, 'Pickering South'],
  L1X: [43.856, -79.097, 'Pickering Central'],
  L1Y: [43.956, -79.119, 'Pickering North'],
  L1Z: [43.877, -79.005, 'Ajax East'],
  L2A: [42.900, -78.933, 'Fort Erie'],
  L2E: [43.054, -79.102, 'Niagara Falls Central'],
  L2G: [43.070, -79.082, 'Niagara Falls Southeast'],
  L2H: [43.101, -79.138, 'Niagara Falls West'],
  L2J: [43.130, -79.103, 'Niagara Falls North'],
  L2M: [43.196, -79.216, 'St. Catharines Northeast'],
  L2N: [43.192, -79.256, 'St. Catharines Northwest'],
  L2P: [43.153, -79.209, 'St. Catharines East'],
  L2R: [43.142, -79.297, 'St. Catharines Central'],
  L2S: [43.145, -79.263, 'St. Catharines Southwest'],
  L2T: [43.131, -79.232, 'St. Catharines South'],
  L2V: [43.114, -79.204, 'St. Catharines Southeast'],
  L2W: [43.169, -79.279, 'St. Catharines West'],
  L3B: [42.988, -79.222, 'Welland East'],
  L3C: [43.000, -79.266, 'Welland West'],
  L3K: [42.900, -79.233, 'Port Colborne'],
  L3M: [43.200, -79.566, 'Grimsby'],
  L3P: [43.877, -79.269, 'Markham Central'],
  L3R: [43.848, -79.329, 'Markham Outer Southwest'],
  L3S: [43.849, -79.262, 'Markham Southeast'],
  L3T: [43.823, -79.395, 'Thornhill East'],
  L3V: [44.609, -79.421, 'Orillia'],
  L3X: [44.043, -79.491, 'Newmarket Southwest'],
  L3Y: [44.056, -79.456, 'Newmarket Northeast'],
  L3Z: [44.117, -79.566, 'Bradford'],
  L4A: [43.967, -79.250, 'Stouffville'],
  L4B: [43.858, -79.398, 'Richmond Hill Southeast'],
  L4C: [43.867, -79.441, 'Richmond Hill Southwest'],
  L4E: [43.939, -79.435, 'Richmond Hill North'],
  L4G: [44.000, -79.466, 'Aurora'],
  L4H: [43.843, -79.564, 'Woodbridge North'],
  L4J: [43.816, -79.453, 'Thornhill West'],
  L4K: [43.800, -79.483, 'Concord'],
  L4L: [43.806, -79.600, 'Woodbridge South'],
  L4M: [44.400, -79.666, 'Barrie North'],
  L4N: [44.357, -79.693, 'Barrie South'],
  L4P: [44.250, -79.466, 'Keswick'],
  L4R: [44.750, -79.883, 'Midland'],
  L4S: [43.898, -79.414, 'Richmond Hill Central'],
  L4T: [43.714, -79.643, 'Mississauga (Malton)'],
  L4V: [43.694, -79.607, 'Mississauga (Wildwood)'],
  L4W: [43.641, -79.630, 'Mississauga (Matheson / East Rathwood)'],
  L4X: [43.618, -79.579, 'Mississauga (East Applewood / East Dixie / NE Lakeview)'],
  L4Y: [43.603, -79.593, 'Mississauga (West Applewood / West Dixie / NW Lakeview)'],
  L4Z: [43.619, -79.654, 'Mississauga (West Rathwood / East Hurontario / SE Gateway)'],
  L5A: [43.588, -79.609, 'Mississauga (Mississauga Valleys / East Cooksville)'],
  L5B: [43.577, -79.631, 'Mississauga (West Cooksville / Fairview / City Centre / East Creditview)'],
  L5C: [43.562, -79.650, 'Mississauga (West Creditview / Mavis / Erindale)'],
  L5E: [43.584, -79.561, 'Mississauga (Central Lakeview)'],
  L5G: [43.565, -79.585, 'Mississauga (SW Lakeview / Mineola / East Port Credit)'],
  L5H: [43.542, -79.616, 'Mississauga (West Port Credit / Lorne Park / East Sheridan)'],
  L5J: [43.510, -79.630, 'Mississauga (Clarkson / Southdown)'],
  L5K: [43.527, -79.662, 'Mississauga (West Sheridan)'],
  L5L: [43.537, -79.690, 'Mississauga (Erin Mills / Western Business Park)'],
  L5M: [43.564, -79.720, 'Mississauga (Churchill Meadows / Central Erin Mills / South Streetsville)'],
  L5N: [43.592, -79.761, 'Mississauga (Lisgar / Meadowvale)'],
  L5P: [43.690, -79.624, 'Mississauga (YYZ)'],
  L5R: [43.606, -79.671, 'Mississauga (West Hurontario / SW Gateway)'],
  L5S: [43.680, -79.678, 'Mississauga (Cardiff / NE Gateway)'],
  L5T: [43.668, -79.618, 'Mississauga (Courtney Park / East Gateway)'],
  L5V: [43.597, -79.693, 'Mississauga (East Credit)'],
  L5W: [43.631, -79.715, 'Mississauga (Meadowvale Village / West Gateway)'],
  L6A: [43.850, -79.516, 'Maple'],
  L6B: [43.901, -79.218, 'Markham East'],
  L6C: [43.904, -79.339, 'Markham Northwest'],
  L6E: [43.900, -79.268, 'Markham Northeast'],
  L6G: [43.849, -79.335, 'Markham Inner Southwest'],
  L6H: [43.488, -79.710, 'Oakville North'],
  L6J: [43.476, -79.659, 'Oakville Northeast'],
  L6K: [43.440, -79.688, 'Oakville East'],
  L6L: [43.403, -79.719, 'Oakville South'],
  L6M: [43.446, -79.759, 'Oakville West'],
  L6P: [43.794, -79.702, 'Brampton North'],
  L6R: [43.759, -79.760, 'Brampton Northwest'],
  L6S: [43.738, -79.726, 'Brampton North Central'],
  L6T: [43.720, -79.685, 'Brampton East'],
  L6V: [43.706, -79.763, 'Brampton Central'],
  L6W: [43.680, -79.727, 'Brampton Southeast'],
  L6X: [43.666, -79.805, 'Brampton Southwest'],
  L6Y: [43.625, -79.788, 'Brampton South'],
  L6Z: [43.733, -79.795, 'Brampton West Central'],
  L7A: [43.691, -79.838, 'Brampton West'],
  L7B: [43.929, -79.527, 'King City'],
  L7C: [43.875, -79.856, 'Caledon'],
  L7E: [43.880, -79.738, 'Bolton'],
  L7G: [43.650, -79.916, 'Georgetown'],
  L7J: [43.630, -80.041, 'Acton'],
  L7K: [43.860, -79.996, 'Caledon Village'],
  L7L: [43.380, -79.767, 'Burlington Northeast'],
  L7M: [43.434, -79.870, 'Burlington North'],
  L7N: [43.351, -79.784, 'Burlington East'],
  L7P: [43.381, -79.886, 'Burlington West'],
  L7R: [43.375, -79.843, 'Burlington Southeast'],
  L7S: [43.323, -79.809, 'Burlington South'],
  L7T: [43.308, -79.851, 'Burlington Southwest'],
  L8B: [43.333, -79.883, 'Waterdown'],
  L8E: [43.224, -79.699, 'Hamilton (Confederation Park / Nashdale / East Kentley / Riverdale / Lakely / Grayside / North Stoney Creek)'],
  L8G: [43.216, -79.742, 'Hamilton (Greenford / North Gershome / West Stoney Creek)'],
  L8H: [43.260, -79.793, 'Hamilton (West Kentley / McQuesten / Parkview / Hamilton Beach / East Industrial Sector / Normanhurst / Homeside / East Crown Point)'],
  L8J: [43.184, -79.721, 'Hamilton (East Albion Falls / South Stoney Creek)'],
  L8K: [43.221, -79.799, 'Hamilton (East Delta / Bartonville / Glenview / Rosedale / Lower King\'s Forest / Red Hill / Corman / Vincent / South Gershome)'],
  L8L: [43.278, -79.834, 'Hamilton (West Industrial Sector / West Crown Point / North Stipley / North Gibson / Landsdale / Keith / North End / Beasley)'],
  L8M: [43.244, -79.836, 'Hamilton (West Delta / Blakeley / South Stipley / South Gibson / St. Clair)'],
  L8N: [43.402, -80.017, 'Hamilton (Stinson / Corktown)'],
  L8P: [43.251, -79.892, 'Hamilton (Durand / Kirkendall / Chedoke Park)'],
  L8R: [43.273, -79.879, 'Hamilton (Central / Strathcona / South Dundurn)'],
  L8S: [43.261, -79.916, 'Hamilton (Westdale / Cootes Paradise / Ainslie Wood)'],
  L8T: [43.220, -79.829, 'Hamilton (Sherwood / Huntington / Upper King\'s Forest / Lisgar / Berrisfield / Hampton Heights / Sunninghill)'],
  L8V: [43.227, -79.850, 'Hamilton (Raleigh / Macassa / Lawfield / Thorner / Burkholme / Eastmount)'],
  L8W: [43.196, -79.846, 'Hamilton (West Albion Falls / Hannon / Rymal / Trenholme / Quinndale / Templemead / Broughton / Eleanor / Randall / Rushdale / Butler / East Chappel)'],
  L9A: [43.227, -79.871, 'Hamilton (Crerar / Bruleville / Hill Park / Inch Park / Centremount / Balfour / Greeningdon / Jerome)'],
  L9B: [43.206, -79.900, 'Hamilton (Barnstown / West Chappel / Allison / Ryckmans / Mewburn / Sheldon / Falkirk / Carpenter / Kennedy / Southwest Outskirts)'],
  L9C: [43.231, -79.905, 'Hamilton (Southam / Bonnington / Yeoville / Kernighan / Gourley / Rolston / Buchanan / Mohawk / Westcliffe / Gilbert / Gilkson / Gurnett / Fessenden / Mountview)'],
  L9E: [43.517, -79.883, 'Milton'],
  L9G: [43.184, -79.990, 'Ancaster West'],
  L9H: [43.264, -79.952, 'Dundas'],
  L9J: [44.319, -79.676, 'Barrie'],
  L9K: [43.225, -79.943, 'Ancaster East'],
  L9L: [44.107, -78.944, 'Port Perry'],
  L9M: [44.783, -79.916, 'Penetanguishene'],
  L9N: [44.115, -79.501, 'Holland Landing'],
  L9P: [44.100, -79.116, 'Uxbridge'],
  L9R: [44.150, -79.866, 'Alliston'],
  L9S: [44.300, -79.650, 'Innisfil'],
  L9T: [43.515, -79.884, 'Milton'],
  L9V: [43.960, -80.108, 'Orangeville North'],
  L9W: [43.970, -80.016, 'Orangeville South'],
  L9X: [44.495, -79.850, 'Springwater'],
  L9Y: [44.483, -80.216, 'Collingwood'],
  L9Z: [44.517, -80.016, 'Wasaga Beach'],
  M1B: [43.811, -79.193, 'Scarborough (Malvern / Rouge River)'],
  M1C: [43.788, -79.156, 'Scarborough (Rouge Hill / Port Union / Highland Creek)'],
  M1E: [43.768, -79.187, 'Scarborough (Guildwood / Morningside / Ellesmere)'],
  M1G: [43.771, -79.214, 'Scarborough (Woburn)'],
  M1H: [43.769, -79.239, 'Scarborough (Cedarbrae)'],
  M1J: [43.746, -79.232, 'Scarborough (Eglinton)'],
  M1K: [43.730, -79.264, 'Scarborough (Kennedy Park / Ionview / East Birchmount Park)'],
  M1L: [43.712, -79.284, 'Scarborough (The Golden Mile / Clairlea / Oakridge / Birchmount Park East)'],
  M1M: [43.725, -79.231, 'Scarborough (Cliffside / Cliffcrest / Scarborough Village West)'],
  M1N: [43.695, -79.265, 'Scarborough (Birch Cliff / Cliffside West)'],
  M1P: [43.761, -79.271, 'Scarborough (Dorset Park / Wexford Heights / Scarborough Town Centre)'],
  M1R: [43.751, -79.300, 'Scarborough (Wexford / Maryvale)'],
  M1S: [43.795, -79.264, 'Scarborough (Agincourt)'],
  M1T: [43.781, -79.304, 'Scarborough (Clarks Corners / Tam O\'Shanter / Sullivan)'],
  M1V: [43.818, -79.282, 'Scarborough (Milliken / Agincourt North / Steeles East / L\'Amoreaux East)'],
  M1W: [43.802, -79.322, 'Scarborough (Steeles West / L\'Amoreaux West)'],
  M1X: [43.834, -79.207, 'Scarborough (Upper Rouge)'],
  M2H: [43.801, -79.358, 'North York (Hillcrest Village)'],
  M2J: [43.780, -79.348, 'North York (Fairview / Henry Farm / Oriole)'],
  M2K: [43.780, -79.381, 'North York (Bayview Village)'],
  M2L: [43.755, -79.376, 'North York (York Mills / Silver Hills)'],
  M2M: [43.791, -79.410, 'Willowdale East (Newtonbrook)'],
  M2N: [43.767, -79.411, 'Willowdale South'],
  M2P: [43.750, -79.398, 'North York (York Mills West)'],
  M2R: [43.779, -79.445, 'Willowdale West'],
  M3A: [43.755, -79.330, 'North York (York Heights / Victoria Village / Parkway East)'],
  M3B: [43.745, -79.359, 'Don Mills North'],
  M3C: [43.733, -79.333, 'Don Mills South (Flemingdon Park)'],
  M3H: [43.754, -79.447, 'North York (Armour Heights / Wilson Heights / Downsview North)'],
  M3J: [43.769, -79.492, 'North York (Northwood Park / York University)'],
  M3K: [43.739, -79.469, 'Downsview East (CFB Toronto)'],
  M3L: [43.733, -79.512, 'Downsview West'],
  M3M: [43.732, -79.493, 'Downsview Central'],
  M3N: [43.757, -79.521, 'North York (Jane and Finch)'],
  M4A: [43.728, -79.315, 'North York (Sweeney Park / Wigmore Park)'],
  M4B: [43.706, -79.309, 'East York (Parkview Hill / Woodbine Gardens)'],
  M4C: [43.691, -79.312, 'East York (Woodbine Heights)'],
  M4E: [43.678, -79.294, 'East Toronto (The Beaches)'],
  M4G: [43.712, -79.364, 'East York (Leaside)'],
  M4H: [43.706, -79.346, 'East York (Thorncliffe Park)'],
  M4J: [43.687, -79.337, 'East Toronto (The Danforth East)'],
  M4K: [43.680, -79.354, 'East Toronto (The Danforth West / Riverdale)'],
  M4L: [43.669, -79.316, 'East Toronto (India Bazaar / The Beaches West)'],
  M4M: [43.656, -79.341, 'East Toronto (Studio District)'],
  M4N: [43.730, -79.394, 'Central Toronto (Lawrence Park East)'],
  M4P: [43.714, -79.389, 'Central Toronto (Davisville North)'],
  M4R: [43.714, -79.406, 'Central Toronto (North Toronto West)'],
  M4S: [43.702, -79.385, 'Central Toronto (Davisville)'],
  M4T: [43.690, -79.385, 'Central Toronto (Moore Park / Summerhill East)'],
  M4V: [43.686, -79.403, 'Central Toronto (Summerhill West / Rathnelly / South Hill / Forest Hill SE / Deer Park)'],
  M4W: [43.683, -79.373, 'Downtown Toronto (Rosedale)'],
  M4X: [43.668, -79.369, 'Downtown Toronto (St. James Town / Cabbagetown)'],
  M4Y: [43.666, -79.383, 'Downtown Toronto (Church and Wellesley)'],
  M5A: [43.656, -79.363, 'Toronto'],
  M5B: [43.657, -79.378, 'Downtown Toronto (Ryerson)'],
  M5C: [43.651, -79.376, 'Downtown Toronto (St. James Park)'],
  M5E: [43.646, -79.375, 'Downtown Toronto (Berczy Park)'],
  M5G: [43.656, -79.386, 'Downtown Toronto (Central Bay Street)'],
  M5H: [43.650, -79.383, 'Downtown Toronto (Richmond / Adelaide / King)'],
  M5J: [43.623, -79.394, 'Downtown Toronto (Harbourfront East / Union Station / Toronto Island)'],
  M5K: [43.647, -79.382, 'Downtown Toronto (Toronto Dominion Centre / Design Exchange)'],
  M5L: [43.649, -79.382, 'Downtown Toronto (Commerce Court / Victoria Hotel)'],
  M5M: [43.733, -79.418, 'North York (Bedford Park / Lawrence Park West / Lawrence Manor East)'],
  M5N: [43.711, -79.419, 'Central Toronto (Roselawn)'],
  M5P: [43.697, -79.412, 'Central Toronto (Forest Hill North & West)'],
  M5R: [43.674, -79.403, 'Central Toronto (The Annex / North Midtown / Yorkville)'],
  M5S: [43.663, -79.399, 'Downtown Toronto (University of Toronto / Harbord)'],
  M5T: [43.654, -79.398, 'Downtown Toronto (Kensington Market / Chinatown / Grange Park)'],
  M5V: [43.640, -79.400, 'Downtown Toronto (CN Tower / King and Spadina / Railway Lands / Harbourfront West / Bathurst Quay / South Niagara / YTZ)'],
  M5W: [43.644, -79.379, 'Downtown Toronto Stn A PO Boxes 25 The Esplanade (Enclave of M5E)'],
  M5X: [43.649, -79.382, 'Downtown Toronto (Underground city)'],
  M6A: [43.722, -79.450, 'North York (Lawrence Manor / Lawrence Heights)'],
  M6B: [43.708, -79.448, 'North York (Glencairn)'],
  M6C: [43.691, -79.431, 'York (Cedarvale)'],
  M6E: [43.689, -79.451, 'York (Fairbank / Oakwood)'],
  M6G: [43.668, -79.421, 'Downtown Toronto (Christie)'],
  M6H: [43.666, -79.438, 'West Toronto (Dufferin / Dovercourt Village)'],
  M6J: [43.648, -79.418, 'West Toronto (Rua Aþores / Trinity)'],
  M6K: [43.638, -79.430, 'West Toronto (Brockton / Parkdale Village / Exhibition Place)'],
  M6L: [43.714, -79.487, 'North York (North Park / Maple Leaf Park / Upwood Park)'],
  M6M: [43.693, -79.486, 'York (Del Ray / Keelsdale / Mount Dennis / Silverthorne)'],
  M6N: [43.675, -79.484, 'York (Runnymede / The Junction North)'],
  M6P: [43.660, -79.463, 'West Toronto (High Park / The Junction South)'],
  M6R: [43.647, -79.452, 'West Toronto (Parkdale / Roncesvalles Village)'],
  M6S: [43.651, -79.483, 'West Toronto (Bloor West Village / Swansea)'],
  M7A: [43.664, -79.389, 'Queen\'s Park Ontario Provincial Government'],
  M7Y: [43.780, -79.251, 'East Toronto Business Reply Mail Processing Centre 969 Eastern (Enclave of M4L)'],
  M8V: [43.608, -79.501, 'Etobicoke (New Toronto / Mimico South / Humber Bay Shores)'],
  M8W: [43.602, -79.540, 'Etobicoke (Alderwood / Long Branch)'],
  M8X: [43.652, -79.508, 'Etobicoke (The Kingsway / Montgomery Road / Old Mill North)'],
  M8Y: [43.633, -79.494, 'Etobicoke (Old Mill South / King\'s Mill Park / Sunnylea / Humber Bay / Mimico NE / The Queensway East / Royal York South East / Kingsway Park South East)'],
  M8Z: [43.626, -79.523, 'Etobicoke (Mimico NW / The Queensway West / South of Bloor / Kingsway Park South West / Royal York South West)'],
  M9A: [43.666, -79.528, 'Etobicoke (Islington Avenue)'],
  M9B: [43.651, -79.552, 'Etobicoke (West Deane Park / Princess Gardens / Martin Grove / Islington / Cloverdale)'],
  M9C: [43.644, -79.577, 'Etobicoke (Eringate / Bloordale Gardens / Old Burnhamthorpe / Markland Woods)'],
  M9L: [43.760, -79.556, 'North York (Humber Summit)'],
  M9M: [43.737, -79.540, 'North York (Humberlea / Emery)'],
  M9N: [43.707, -79.517, 'Weston'],
  M9P: [43.695, -79.532, 'Etobicoke (Westmount)'],
  M9R: [43.690, -79.558, 'Etobicoke (Kingsview Village / St. Phillips / Martin Grove Gardens / Richview Gardens)'],
  M9V: [43.743, -79.588, 'Etobicoke (South Steeles / Silverstone / Humbergate / Jamestown / Mount Olive / Beaumond Heights / Thistletown / Albion Gardens)'],
  M9W: [43.714, -79.591, 'Etobicoke Northwest (Clairville / Humberwood / Woodbine Downs / West Humber / Kipling Heights / Rexdale / Elms / Tandridge / Old Rexdale)'],
  N0A: [42.940, -79.945, 'West Haldimand (Port Dover)'],
  N0B: [43.557, -80.441, 'Wellington (Elora)'],
  N0C: [44.256, -80.503, 'Georgian Bay Southwest Shore (Dundalk)'],
  N0E: [42.662, -80.557, 'Brant and Norfolk (Waterford)'],
  N0G: [44.002, -81.068, 'Huron (Wingham)'],
  N0H: [44.694, -81.096, 'Bruce Peninsula (Wiarton)'],
  N0J: [42.977, -80.706, 'Oxford (Norwich)'],
  N0K: [43.507, -81.158, 'Perth (Mitchell)'],
  N0L: [42.756, -81.453, 'Elgin (Dorchester)'],
  N0M: [43.279, -81.544, 'Middlesex (Clinton)'],
  N0N: [42.906, -82.110, 'Lambton (Forest)'],
  N0P: [42.404, -81.911, 'Kent (Blenheim)'],
  N0R: [42.178, -82.772, 'Essex (Belle River)'],
  N1A: [42.900, -79.616, 'Dunnville'],
  N1C: [43.492, -80.227, 'Guelph South'],
  N1E: [43.568, -80.242, 'Guelph North'],
  N1G: [43.518, -80.226, 'Guelph Central'],
  N1H: [43.559, -80.300, 'Guelph Northwest'],
  N1K: [43.526, -80.305, 'Guelph West'],
  N1L: [43.516, -80.190, 'Guelph East'],
  N1M: [43.700, -80.366, 'Fergus'],
  N1P: [43.340, -80.296, 'Cambridge South'],
  N1R: [43.367, -80.224, 'Cambridge Central'],
  N1S: [43.359, -80.335, 'Cambridge Southwest'],
  N1T: [43.385, -80.283, 'Cambridge East'],
  N2A: [43.441, -80.425, 'Kitchener East'],
  N2B: [43.465, -80.447, 'Kitchener Northeast'],
  N2C: [43.418, -80.445, 'Kitchener South Central'],
  N2E: [43.411, -80.501, 'Kitchener Southwest'],
  N2G: [43.444, -80.489, 'Kitchener Central'],
  N2H: [43.458, -80.482, 'Kitchener North Central'],
  N2J: [43.504, -80.537, 'Waterloo Southeast'],
  N2K: [43.496, -80.494, 'Kitchener North'],
  N2L: [43.471, -80.545, 'Waterloo South'],
  N2M: [43.436, -80.509, 'Kitchener Northwest'],
  N2N: [43.426, -80.544, 'Kitchener West'],
  N2P: [43.388, -80.430, 'Kitchener Southeast'],
  N2R: [43.385, -80.487, 'Kitchener South'],
  N2T: [43.453, -80.569, 'Waterloo Southwest'],
  N2V: [43.476, -80.584, 'Waterloo Northwest'],
  N2Z: [44.166, -81.601, 'Kincardine'],
  N3A: [43.400, -80.650, 'Baden'],
  N3B: [43.600, -80.550, 'Elmira'],
  N3C: [43.439, -80.265, 'Cambridge Northeast'],
  N3E: [43.419, -80.350, 'Cambridge Northwest'],
  N3H: [43.427, -80.370, 'Cambridge West'],
  N3L: [43.200, -80.383, 'Paris'],
  N3P: [43.182, -80.237, 'Brantford Northeast'],
  N3R: [43.169, -80.268, 'Brantford Central'],
  N3S: [43.139, -80.236, 'Brantford Southeast'],
  N3T: [43.131, -80.325, 'Brantford Southwest'],
  N3V: [43.173, -80.298, 'Brantford Northwest'],
  N3W: [43.067, -79.933, 'Caledonia'],
  N3Y: [42.833, -80.300, 'Simcoe'],
  N4B: [42.850, -80.500, 'Delhi'],
  N4G: [42.860, -80.726, 'Tillsonburg'],
  N4K: [44.567, -80.944, 'Owen Sound'],
  N4L: [44.600, -80.583, 'Meaford'],
  N4N: [44.150, -81.033, 'Hanover'],
  N4S: [43.143, -80.734, 'Woodstock Central'],
  N4T: [43.148, -80.732, 'Woodstock North'],
  N4V: [43.115, -80.743, 'Woodstock South'],
  N4W: [43.733, -80.950, 'Listowel'],
  N4X: [43.266, -81.169, 'St. Mary\'s'],
  N4Z: [43.363, -81.007, 'Stratford South'],
  N5A: [43.367, -80.950, 'Stratford North'],
  N5C: [43.033, -80.883, 'Ingersoll'],
  N5H: [42.767, -80.983, 'Aylmer'],
  N5L: [42.667, -81.216, 'Port Stanley'],
  N5P: [42.778, -81.177, 'St. Thomas North'],
  N5R: [42.760, -81.176, 'St. Thomas South'],
  N5V: [43.023, -81.164, 'London (YXU / North and East Argyle / East Huron Heights)'],
  N5W: [42.986, -81.182, 'London East (SW Argyle / Hamilton Road)'],
  N5X: [43.044, -81.239, 'London (Fanshawe / Stoneybrook / Stoney Creek / Uplands / East Masonville)'],
  N5Y: [43.012, -81.231, 'London (West Huron Heights / Carling)'],
  N5Z: [42.966, -81.205, 'London (Glen Cairn)'],
  N6A: [42.998, -81.256, 'London North (UWO)'],
  N6B: [42.983, -81.239, 'London Central'],
  N6C: [42.958, -81.238, 'London South (East Highland / North White Oaks / North Westminster)'],
  N6E: [42.919, -81.224, 'London (South White Oaks / Central Westminster / East Longwoods / West Brockley)'],
  N6G: [43.015, -81.305, 'London (Sunningdale / West Masonville / Medway / NE Hyde Park / East Fox Hollow)'],
  N6H: [42.992, -81.340, 'London West (Central Hyde Park / Oakridge)'],
  N6J: [42.955, -81.273, 'London (Southcrest / East Westmount / West Highland)'],
  N6K: [42.954, -81.342, 'London (Riverbend / Woodhull / North Sharon Creek / Byron / West Westmount)'],
  N6L: [42.872, -81.247, 'London (East Tempo)'],
  N6M: [42.963, -81.139, 'London (Jackson / Old Victoria / Bradley / North Highbury)'],
  N6N: [42.900, -81.159, 'London (South Highbury / Glanworth / East Brockley / SE Westminster)'],
  N6P: [42.891, -81.324, 'London (Talbot / Lambeth / West Tempo / South Sharon Creek)'],
  N7A: [43.750, -81.716, 'Goderich'],
  N7G: [42.955, -81.622, 'Strathroy'],
  N7L: [42.421, -82.199, 'Chatham Northwest'],
  N7M: [42.424, -82.118, 'Chatham Southeast'],
  N7S: [42.989, -82.359, 'Sarnia Central'],
  N7T: [42.958, -82.278, 'Sarnia Southwest'],
  N7V: [43.000, -82.393, 'Sarnia Northwest'],
  N7W: [42.964, -82.326, 'Sarnia Southeast'],
  N7X: [43.021, -82.321, 'Sarnia Northeast'],
  N8A: [42.593, -82.388, 'Wallaceburg'],
  N8H: [42.055, -82.606, 'Leamington'],
  N8M: [42.175, -82.825, 'Essex'],
  N8N: [42.295, -82.867, 'Tecumseh Outskirts'],
  N8P: [42.328, -82.910, 'Windsor (East Riverside)'],
  N8R: [42.307, -82.915, 'Windsor (East Forest Glade)'],
  N8S: [42.328, -82.947, 'Windsor (Riverside)'],
  N8T: [42.304, -82.946, 'Windsor (West Forest Glade / East Fontainbleu)'],
  N8V: [42.277, -82.945, 'Tecumseh (YQG)'],
  N8W: [42.284, -82.977, 'Windsor (South Walkerville / West Fontainbleu / Walker Farm / Devonshire)'],
  N8X: [42.293, -83.019, 'Windsor South Central (West Walkerville / Remington Park)'],
  N8Y: [42.318, -82.993, 'Windsor East (East Walkerville)'],
  N9A: [42.201, -83.028, 'Windsor (City Centre / NW Walkerville)'],
  N9B: [42.295, -83.052, 'Windsor (University / South Cameron)'],
  N9C: [42.277, -83.079, 'Windsor (Sandwich / Ojibway / West Malden)'],
  N9E: [42.265, -83.031, 'Windsor South (East Malden)'],
  N9G: [42.248, -82.995, 'Windsor (Roseland)'],
  N9H: [42.232, -83.028, 'La Salle East'],
  N9J: [42.219, -83.080, 'La Salle West'],
  N9K: [42.298, -82.870, 'Tecumseh Central'],
  N9V: [42.117, -83.050, 'Amherstburg'],
  N9Y: [42.050, -82.760, 'Kingsville'],
  P0A: [45.588, -79.355, 'Nipissing Central (Burk\'s Falls)'],
  P0B: [45.186, -79.412, 'Nipissing South (Utterson)'],
  P0C: [45.127, -79.786, 'Parry Sound Mid-Shore (Bala)'],
  P0E: [44.861, -79.507, 'Parry Sound South Shore (Kilworthy)'],
  P0G: [45.672, -80.369, 'Parry Sound North Shore (Nobel)'],
  P0H: [46.311, -79.362, 'Nipissing North (Callander)'],
  P0J: [47.578, -80.204, 'Timiskaming South (Temiskaming Shores)'],
  P0K: [48.523, -80.308, 'Timiskaming North (Iroquois Falls A)'],
  P0L: [51.970, -83.537, 'Cochrane Region (Hearst)'],
  P0M: [47.653, -82.475, 'Algoma, Sudbury District and Greater Sudbury (Chelmsford)'],
  P0N: [48.603, -81.011, 'Timmins Region (South Porcupine)'],
  P0P: [45.757, -82.215, 'Manitoulin (Little Current)'],
  P0R: [46.598, -83.038, 'Algoma Southwest (Blind River)'],
  P0S: [48.048, -84.673, 'Lake Superior East Shore (Wawa)'],
  P0T: [49.292, -88.756, 'Lake Superior North Shore (Marathon)'],
  P0V: [52.965, -90.150, 'Northwestern Ontario (Red Lake)'],
  P0W: [48.875, -93.752, 'Rainy River Region (Emo)'],
  P0X: [50.929, -93.309, 'Kenora Region (Keewatin)'],
  P0Y: [49.760, -95.100, 'Lake of the Woods East Shore (Ingolf)'],
  P1A: [46.280, -79.450, 'North Bay South'],
  P1B: [46.336, -79.583, 'North Bay Central'],
  P1C: [46.340, -79.422, 'North Bay North'],
  P1H: [45.333, -79.216, 'Huntsville'],
  P1L: [45.033, -79.316, 'Bracebridge'],
  P1P: [44.917, -79.366, 'Gravenhurst'],
  P2A: [45.350, -80.033, 'Parry Sound'],
  P2B: [46.367, -79.916, 'Sturgeon Falls'],
  P2N: [48.145, -80.038, 'Kirkland Lake'],
  P3A: [46.519, -80.934, 'Greater Sudbury (New Sudbury)'],
  P3B: [46.485, -80.930, 'Greater Sudbury (Downtown / Minnow Lake)'],
  P3C: [46.513, -81.022, 'Greater Sudbury (Gatchell / West End / Little Britain)'],
  P3E: [46.268, -80.906, 'Greater Sudbury (Robinson / Lockerby)'],
  P3G: [46.403, -80.975, 'Greater Sudbury (Lo-Ellen / McFarlane Lake)'],
  P3L: [46.594, -80.850, 'Greater Sudbury (Garson)'],
  P3N: [46.584, -81.003, 'Greater Sudbury (Val Caron)'],
  P3P: [46.726, -81.017, 'Greater Sudbury (Hanmer)'],
  P3Y: [46.443, -81.127, 'Greater Sudbury (Lively)'],
  P4N: [48.467, -81.333, 'Timmins Southeast'],
  P4P: [48.498, -81.345, 'Timmins North'],
  P4R: [48.470, -81.400, 'Timmins West'],
  P5A: [46.383, -82.633, 'Elliot Lake'],
  P5E: [46.258, -81.766, 'Espanola'],
  P5N: [49.417, -82.433, 'Kapuskasing'],
  P6A: [46.517, -84.333, 'Sault Ste. Marie East'],
  P6B: [46.531, -84.305, 'Sault Ste. Marie Central'],
  P6C: [46.535, -84.373, 'Sault Ste. Marie North'],
  P7A: [48.460, -89.204, 'Thunder Bay Northeast'],
  P7B: [48.947, -89.406, 'Thunder Bay North Central'],
  P7C: [48.352, -89.465, 'Thunder Bay Central'],
  P7E: [48.368, -89.284, 'Thunder Bay South Central'],
  P7G: [48.400, -89.317, 'Thunder Bay North'],
  P7J: [48.283, -89.367, 'Thunder Bay South'],
  P7K: [48.373, -89.348, 'Thunder Bay West'],
  P7L: [48.167, -89.417, 'Neebing'],
  P8N: [49.783, -92.750, 'Dryden'],
  P8T: [50.067, -91.984, 'Sioux Lookout'],
  P9A: [48.639, -93.447, 'Fort Frances'],
  P9N: [49.757, -94.343, 'Kenora'],
  R0A: [49.291, -96.299, 'Southeastern Manitoba (Lorette)'],
  R0B: [56.270, -96.912, 'Northern Manitoba (Norway House)'],
  R0C: [51.413, -97.853, 'North Interlake (Stonewall)'],
  R0E: [50.475, -95.961, 'Eastern Manitoba (Beausejour)'],
  R0G: [49.439, -98.087, 'South Central Manitoba (Altona)'],
  R0H: [50.346, -98.515, 'South Interlake (MacGregor)'],
  R0J: [50.584, -100.135, 'Riding Mountain (Neepawa)'],
  R0K: [49.555, -99.715, 'Brandon Region (Killarney)'],
  R0L: [52.009, -100.290, 'Western Manitoba (Swan River)'],
  R0M: [49.711, -100.926, 'Southwestern Manitoba (Virden)'],
  R1A: [50.144, -96.885, 'Selkirk'],
  R1B: [50.084, -96.935, 'Lockport'],
  R1C: [50.055, -96.978, 'Narol'],
  R1N: [49.973, -98.293, 'Portage la Prairie'],
  R2C: [49.925, -96.956, 'Winnipeg (Transcona)'],
  R2E: [49.979, -97.013, 'East St. Paul'],
  R2G: [49.941, -97.057, 'Winnipeg (River East North)'],
  R2H: [49.885, -97.119, 'Winnipeg (St. Boniface NW)'],
  R2J: [49.867, -97.063, 'Winnipeg (St. Boniface NE)'],
  R2K: [49.920, -97.083, 'Winnipeg (River East Central)'],
  R2L: [49.907, -97.100, 'Winnipeg (River East South)'],
  R2M: [49.840, -97.115, 'Winnipeg (St. Vital North)'],
  R2N: [49.784, -97.097, 'Winnipeg (St. Vital SW)'],
  R2P: [49.970, -97.155, 'Winnipeg (Seven Oaks West)'],
  R2R: [49.938, -97.216, 'Winnipeg (Inkster West)'],
  R2V: [49.955, -97.111, 'Winnipeg (Seven Oaks East)'],
  R2W: [49.919, -97.135, 'Winnipeg (Point Douglas East)'],
  R2X: [49.932, -97.173, 'Winnipeg (Point Douglas West / Inkster East)'],
  R2Y: [49.907, -97.294, 'Winnipeg (St. James-Assiniboia NW)'],
  R3A: [49.904, -97.149, 'Winnipeg (Centennial)'],
  R3B: [49.898, -97.140, 'Winnipeg (Chinatown / Civic Centre / Exchange District)'],
  R3C: [50.011, -97.218, 'Winnipeg (Broadway / The Forks / Portage and Main) Manitoba Provincial Government'],
  R3E: [49.908, -97.178, 'Winnipeg (Sargent Park / Daniel McIntyre / Inkster SE)'],
  R3G: [49.888, -97.181, 'Winnipeg (Minto / St. Mathews / Wolseley)'],
  R3H: [49.903, -97.207, 'Winnipeg (St. James-Assiniboia NE / YWG)'],
  R3J: [49.897, -97.240, 'Winnipeg (St. James-Assiniboia SE)'],
  R3K: [49.873, -97.307, 'Winnipeg (St. James-Assiniboia SW)'],
  R3L: [49.867, -97.136, 'Winnipeg (River Heights East)'],
  R3M: [49.862, -97.166, 'Winnipeg (River Heights Central)'],
  R3N: [49.863, -97.196, 'Winnipeg (River Heights West)'],
  R3P: [49.843, -97.218, 'Winnipeg (Fort Garry NW / Tuxedo)'],
  R3R: [49.855, -97.287, 'Winnipeg (Assiniboine South / Betsworth)'],
  R3S: [49.825, -97.293, 'Winnipeg (Wilkes South)'],
  R3T: [49.814, -97.153, 'Winnipeg (Fort Garry NE / University of Manitoba)'],
  R3V: [49.746, -97.174, 'Winnipeg (Fort Garry South)'],
  R3W: [49.914, -97.040, 'Winnipeg (Grassie / Pequis)'],
  R3X: [49.821, -97.032, 'Winnipeg (St. Boniface South / St. Vital SE)'],
  R3Y: [49.788, -97.215, 'Winnipeg (Fort Garry West)'],
  R4A: [50.021, -97.115, 'West St. Paul'],
  R4G: [49.774, -97.322, 'Oak Bluff'],
  R4H: [49.876, -97.381, 'Headingley East'],
  R4J: [49.847, -97.432, 'Headingley West'],
  R4K: [49.891, -97.600, 'Cartier'],
  R4L: [49.937, -97.555, 'St. Francois Xavier'],
  R5A: [49.712, -97.084, 'St. Adolphe'],
  R5G: [49.526, -96.684, 'Steinbach'],
  R5H: [49.670, -96.650, 'Ste. Anne'],
  R5K: [49.739, -96.872, 'Lorette'],
  R6M: [49.192, -98.101, 'Morden'],
  R6W: [49.182, -97.941, 'Winkler'],
  R7A: [49.817, -99.957, 'Brandon Southeast'],
  R7B: [49.842, -99.983, 'Brandon Southwest'],
  R7C: [49.882, -99.965, 'Brandon North'],
  R7N: [51.149, -100.050, 'Dauphin'],
  R8A: [54.768, -101.865, 'Flin Flon'],
  R8N: [55.743, -97.856, 'Thompson'],
  R9A: [53.704, -101.293, 'The Pas'],
  S0A: [51.482, -102.906, 'Yorkton Region (Melville)'],
  S0C: [49.396, -103.257, 'Southeastern Saskatchewan (Carlyle)'],
  S0E: [53.136, -103.100, 'Eastern Saskatchewan (Melfort)'],
  S0G: [50.577, -104.100, 'South Central Saskatchewan (Fort Qu\'Appelle)'],
  S0H: [49.984, -106.249, 'Southern Saskatchewan (Assiniboia)'],
  S0J: [57.199, -105.824, 'Northern Saskatchewan (La Ronge)'],
  S0K: [52.300, -107.991, 'Central Saskatchewan (Humboldt)'],
  S0L: [51.483, -108.490, 'Western Saskatchewan (Kindersley)'],
  S0M: [54.923, -108.957, 'Northwestern Saskatchewan (Battleford)'],
  S0N: [49.912, -108.724, 'Southwestern Saskatchewan (Maple Creek)'],
  S0P: [55.016, -102.742, 'Northeastern Saskatchewan (Creighton)'],
  S2V: [50.783, -104.951, 'Buena Vista'],
  S3N: [51.217, -102.468, 'Yorkton'],
  S4A: [49.133, -102.984, 'Estevan'],
  S4H: [49.667, -103.851, 'Weyburn'],
  S4K: [50.450, -104.618, 'Rm Of Sherwood'],
  S4L: [50.413, -104.273, 'Regina East'],
  S4M: [50.450, -104.618, 'Regina'],
  S4N: [50.467, -104.541, 'Regina Northeast and East Central'],
  S4P: [50.419, -104.677, 'Regina Central'],
  S4R: [50.486, -104.616, 'Regina North Central'],
  S4S: [50.415, -104.610, 'Regina South Saskatchewan Provincial Government'],
  S4T: [50.451, -104.665, 'Regina West'],
  S4V: [50.425, -104.539, 'Regina Southeast'],
  S4W: [50.408, -104.654, 'Regina Southwest'],
  S4X: [50.506, -104.675, 'Regina Northwest'],
  S4Y: [50.477, -104.699, 'Regina Outer Northwest'],
  S4Z: [50.450, -104.532, 'Regina Northeast'],
  S6H: [50.389, -105.558, 'Moose Jaw Southeast'],
  S6J: [50.419, -105.539, 'Moose Jaw Northeast'],
  S6K: [50.454, -105.642, 'Moose Jaw West'],
  S6V: [54.493, -104.305, 'Prince Albert Central'],
  S6W: [53.178, -105.774, 'Prince Albert Southwest'],
  S6X: [53.194, -105.703, 'Prince Albert East'],
  S7H: [52.117, -106.635, 'Saskatoon East Central'],
  S7J: [52.096, -106.625, 'Saskatoon South Central'],
  S7K: [52.011, -106.796, 'Saskatoon North Central'],
  S7L: [52.156, -106.687, 'Saskatoon West'],
  S7M: [52.113, -106.724, 'Saskatoon Southwest'],
  S7N: [52.140, -106.608, 'Saskatoon Northeast Central'],
  S7P: [52.275, -106.501, 'Saskatoon North'],
  S7R: [52.159, -106.716, 'Saskatoon Northwest'],
  S7S: [52.161, -106.586, 'Saskatoon Northeast'],
  S7T: [52.040, -106.659, 'Saskatoon South'],
  S7V: [52.098, -106.555, 'Saskatoon Southeast'],
  S7W: [52.157, -106.561, 'Saskatoon'],
  S9A: [52.783, -108.285, 'North Battleford'],
  S9H: [50.283, -107.801, 'Swift Current'],
  S9V: [53.283, -110.002, 'Lloydminster'],
  S9X: [54.133, -108.435, 'Meadow Lake'],
  T0A: [54.766, -111.717, 'Eastern Alberta (St. Paul)'],
  T0B: [53.073, -111.582, 'Wainwright Region (Tofield)'],
  T0C: [52.143, -111.694, 'Central Alberta (Stettler)'],
  T0E: [53.676, -115.095, 'Western Alberta (Jasper)'],
  T0G: [55.699, -114.453, 'North Central Alberta (Slave Lake)'],
  T0H: [57.540, -116.915, 'Northwestern Alberta (High Level)'],
  T0J: [50.994, -111.463, 'Southeastern Alberta (Drumheller)'],
  T0K: [49.472, -112.241, 'International Border Region (Cardston)'],
  T0L: [50.631, -114.409, 'Kananaskis Country (Claresholm)'],
  T0M: [51.955, -114.869, 'Central Foothills (Sundre)'],
  T0P: [58.263, -110.747, 'Northeastern Alberta (Fort Chipewyan)'],
  T0V: [59.905, -111.672, 'Remote Northeast (Fitzgerald)'],
  T1A: [50.082, -110.579, 'Medicine Hat Central'],
  T1B: [49.835, -110.520, 'Medicine Hat South'],
  T1C: [50.077, -110.691, 'Medicine Hat North'],
  T1G: [49.787, -112.146, 'Taber'],
  T1H: [49.700, -112.819, 'Lethbridge North'],
  T1J: [49.658, -112.748, 'Lethbridge West and Central'],
  T1K: [49.651, -112.835, 'Lethbridge Southeast'],
  T1L: [51.176, -115.570, 'Banff'],
  T1M: [49.717, -112.618, 'Coaldale'],
  T1P: [51.050, -113.385, 'Strathmore'],
  T1R: [50.583, -111.885, 'Brooks'],
  T1S: [50.736, -113.969, 'Okotoks'],
  T1V: [50.583, -113.869, 'High River'],
  T1W: [51.088, -115.346, 'Canmore'],
  T1X: [51.033, -113.819, 'Chestermere'],
  T1Y: [51.082, -113.958, 'Calgary (Rundle / Whitehorn / Monterey Park)'],
  T1Z: [51.183, -113.935, 'Rocky View'],
  T2A: [51.049, -113.956, 'Calgary (Penbrooke Meadows / Marlborough)'],
  T2B: [51.021, -113.981, 'Calgary (Forest Lawn / Dover / Erin Woods)'],
  T2C: [50.987, -113.963, 'Calgary (Lynnwood Ridge / Ogden / Foothills Industrial / Great Plains)'],
  T2E: [51.088, -114.021, 'Calgary (Bridgeland / Greenview / Zoo / YYC)'],
  T2G: [51.027, -114.035, 'Calgary (Inglewood / Burnsland / Chinatown / East Victoria Park / Saddledome)'],
  T2H: [50.989, -114.052, 'Calgary (Highfield / Burns Industrial)'],
  T2J: [50.848, -114.196, 'Calgary (Queensland Downs / Lake Bonavista / Willow Park / Acadia)'],
  T2K: [51.111, -114.048, 'Calgary (Thornecliffe / Tuxedo)'],
  T2L: [51.105, -114.115, 'Calgary (Brentwood / Collingwood / Nose Hill)'],
  T2M: [51.133, -113.856, 'Calgary (Mount Pleasant / Capitol Hill / Banff Trail)'],
  T2N: [51.062, -114.116, 'Calgary (Kensington / Westmont / Parkdale / University)'],
  T2P: [51.071, -113.693, 'Calgary (City Centre / Calgary Tower)'],
  T2R: [51.041, -114.076, 'Calgary (Connaught / West Victoria Park)'],
  T2S: [51.023, -114.071, 'Calgary (Elbow Park / Britannia / Parkhill / Mission)'],
  T2T: [51.024, -114.100, 'Calgary South (Altadore / Bankview / Richmond)'],
  T2V: [50.982, -114.100, 'Calgary (Oak Ridge / Haysboro / Kingsland / Windsor Park)'],
  T2W: [50.951, -114.359, 'Calgary (Braeside / Woodbine)'],
  T2X: [50.884, -114.033, 'Calgary (Midnapore / Sundance)'],
  T2Y: [50.909, -114.103, 'Calgary (Millrise / Somerset / Bridlewood / Evergreen)'],
  T2Z: [50.928, -113.968, 'Calgary (Douglas Glen / McKenzie Lake / Copperfield / East Shepard)'],
  T3A: [51.126, -114.142, 'Calgary (Dalhousie / Edgemont / Hamptons / Hidden Valley)'],
  T3B: [51.092, -114.207, 'Calgary (Montgomery / Bowness / Silver Springs / Greenwood)'],
  T3C: [51.050, -114.139, 'Calgary (Rosscarrock / Wildwood / Shaganappi / Sunalta)'],
  T3E: [50.990, -114.157, 'Calgary (Lakeview / Glendale / Killarney / Glamorgan)'],
  T3G: [51.139, -114.201, 'Calgary (Hawkwood / Arbour Lake / Royal Oak / Rocky Ridge)'],
  T3H: [51.042, -114.200, 'Calgary (Discovery Ridge / Signal Hill / Aspen Woods / Patterson / Cougar Ridge)'],
  T3J: [51.119, -113.947, 'Calgary (Martindale / Taradale / Falconridge / Saddle Ridge)'],
  T3K: [51.156, -114.057, 'Calgary (Sandstone / Harvest Hills / Coventry Hills / Panorama Hills / Beddington)'],
  T3L: [51.147, -114.313, 'Calgary (Tuscany / Scenic Acres)'],
  T3M: [50.880, -113.956, 'Calgary (Cranston)'],
  T3N: [51.163, -113.954, 'Calgary Northeast'],
  T3P: [51.207, -114.135, 'Calgary (Symons Valley)'],
  T3R: [51.202, -114.245, 'Calgary Northwest'],
  T3S: [50.915, -113.893, 'Calgary'],
  T3Z: [51.069, -114.473, 'Redwood Meadows'],
  T4A: [51.280, -113.988, 'Airdrie East'],
  T4B: [51.308, -114.040, 'Airdrie West'],
  T4C: [51.183, -114.469, 'Cochrane'],
  T4E: [52.276, -113.706, 'Red Deer County'],
  T4G: [52.027, -113.951, 'Innisfail'],
  T4H: [51.783, -114.102, 'Olds'],
  T4J: [52.677, -113.582, 'Ponoka'],
  T4L: [52.467, -113.735, 'Lacombe'],
  T4M: [52.383, -113.785, 'Blackfalds'],
  T4N: [52.232, -113.836, 'Red Deer Central'],
  T4P: [52.295, -113.807, 'Red Deer North'],
  T4R: [52.242, -113.778, 'Red Deer South'],
  T4S: [52.317, -114.085, 'Sylvan Lake'],
  T4T: [52.367, -114.919, 'Rocky Mountain House'],
  T4V: [53.017, -112.835, 'Camrose'],
  T4X: [53.350, -113.419, 'Beaumont'],
  T5A: [53.593, -113.408, 'Edmonton (West Clareview / East Londonderry)'],
  T5B: [53.735, -113.337, 'Edmonton (East North Central / West Beverly)'],
  T5C: [53.600, -113.455, 'Edmonton (Central Londonderry)'],
  T5E: [53.745, -113.447, 'Edmonton (West Londonderry / East Calder)'],
  T5G: [53.571, -113.505, 'Edmonton (North Central / Queen Mary Park / YXD)'],
  T5H: [53.551, -113.492, 'Edmonton (North and East Downtown Fringe)'],
  T5J: [53.543, -113.497, 'Edmonton (North Downtown)'],
  T5K: [53.537, -113.510, 'Edmonton (South Downtown / South Downtown Fringe)'],
  T5L: [53.585, -113.553, 'Edmonton (North Westmount / West Calder / East Mistatim)'],
  T5M: [53.563, -113.566, 'Edmonton (South Westmount / Groat Estate / East Northwest Industrial)'],
  T5N: [53.544, -113.557, 'Edmonton (Glenora / SW Downtown Fringe)'],
  T5P: [53.546, -113.596, 'Edmonton (North Jasper Place)'],
  T5R: [53.518, -113.580, 'Edmonton (Central Jasper Place / Buena Vista)'],
  T5S: [53.563, -113.670, 'Edmonton (West Northwest Industrial / Winterburn)'],
  T5T: [53.519, -113.658, 'Edmonton West (West Jasper Place / West Edmonton Mall)'],
  T5V: [53.585, -113.622, 'Edmonton (Central Mistatim)'],
  T5W: [53.565, -113.402, 'Edmonton (Central Beverly)'],
  T5X: [53.631, -113.525, 'Edmonton (East Castledowns)'],
  T5Y: [53.658, -113.361, 'Edmonton (Landbank / Oliver / East Lake District)'],
  T5Z: [53.636, -113.467, 'Edmonton (West Lake District)'],
  T6A: [53.548, -113.432, 'Edmonton (North Capilano)'],
  T6B: [53.513, -113.419, 'Edmonton (SE Capilano / West Southeast Industrial / East Bonnie Doon)'],
  T6C: [53.522, -113.459, 'Edmonton (Central Bonnie Doon)'],
  T6E: [53.491, -113.480, 'Edmonton (South Bonnie Doon / East University)'],
  T6G: [53.521, -113.532, 'Edmonton (West University / Strathcona Place)'],
  T6H: [53.375, -113.459, 'Edmonton (Southgate / North Riverbend)'],
  T6J: [53.456, -113.521, 'Edmonton (Kaskitayo)'],
  T6K: [53.461, -113.452, 'Edmonton (West Mill Woods)'],
  T6L: [53.459, -113.415, 'Edmonton (East Mill Woods)'],
  T6M: [53.459, -113.655, 'Edmonton Southwest'],
  T6N: [53.465, -113.478, 'Edmonton (South Industrial)'],
  T6P: [53.508, -113.372, 'Edmonton (East Southeast Industrial / South Clover Bar)'],
  T6R: [53.457, -113.580, 'Edmonton (Riverbend)'],
  T6S: [53.581, -113.337, 'Edmonton (North Clover Bar)'],
  T6T: [53.462, -113.371, 'Edmonton (Meadows)'],
  T6V: [53.611, -113.575, 'Edmonton (West Castledowns)'],
  T6W: [53.418, -113.579, 'Edmonton (Heritage Valley)'],
  T6X: [53.415, -113.418, 'Edmonton (Ellerslie)'],
  T7A: [53.217, -114.985, 'Drayton Valley'],
  T7E: [53.583, -116.436, 'Edson'],
  T7N: [54.133, -114.402, 'Barrhead'],
  T7P: [54.150, -113.869, 'Westlock'],
  T7S: [54.150, -115.686, 'Whitecourt'],
  T7V: [53.400, -117.586, 'Hinton'],
  T7X: [53.533, -113.919, 'Spruce Grove North'],
  T7Y: [53.418, -113.810, 'Spruce Grove South'],
  T7Z: [53.533, -114.002, 'Stony Plain'],
  T8A: [53.528, -113.251, 'Sherwood Park West'],
  T8B: [53.440, -113.295, 'Sherwood Park Outer Southwest'],
  T8C: [53.439, -113.190, 'Sherwood Park Inner Southwest'],
  T8E: [53.523, -113.102, 'Sherwood Park Central'],
  T8G: [53.505, -112.953, 'Sherwood Park East'],
  T8H: [53.556, -113.295, 'Sherwood Park Northwest'],
  T8L: [53.717, -113.219, 'Fort Saskatchewan'],
  T8N: [53.633, -113.635, 'St. Albert'],
  T8R: [53.800, -113.652, 'Morinville'],
  T8S: [56.250, -117.286, 'Peace River'],
  T8T: [53.687, -113.710, 'St. Albert'],
  T8V: [55.181, -118.910, 'Grande Prairie Central'],
  T8W: [55.130, -118.795, 'Grande Prairie South'],
  T8X: [55.183, -118.746, 'Grande Prairie East'],
  T9A: [52.967, -113.369, 'Wetaskiwin'],
  T9C: [53.500, -112.052, 'Vegreville'],
  T9E: [53.267, -113.552, 'Leduc'],
  T9G: [53.367, -113.735, 'Devon'],
  T9H: [56.664, -111.136, 'Fort McMurray Outer Central'],
  T9J: [56.707, -111.377, 'Fort McMurray Inner Central'],
  T9K: [56.754, -111.435, 'Fort McMurray Northwest'],
  T9M: [54.450, -110.202, 'Cold Lake'],
  T9N: [54.267, -110.735, 'Bonnyville'],
  T9S: [54.717, -113.285, 'Athabasca'],
  T9V: [53.272, -110.085, 'Lloydminster'],
  T9W: [52.839, -110.857, 'Wainwright'],
  T9X: [53.367, -110.852, 'Vermilion'],
  V0A: [51.299, -116.939, 'Upper Columbia Region (Golden)'],
  V0B: [49.678, -115.564, 'East Kootenays (Fernie)'],
  V0C: [58.387, -125.717, 'Northern British Columbia (Fort Nelson)'],
  V0E: [51.505, -119.203, 'Central Okanagan and High Country (Revelstoke)'],
  V0G: [50.053, -117.429, 'West Kootenays (Rossland)'],
  V0H: [49.409, -119.005, 'South Okanagan (Summerland)'],
  V0J: [55.996, -126.857, 'Omineca and Yellowhead (Smithers)'],
  V0K: [51.437, -121.638, 'Cariboo and West Okanagan (100 Mile House)'],
  V0L: [52.099, -123.653, 'Chilcotin (Alexis Creek)'],
  V0M: [49.635, -122.038, 'Harrison Lake Region (Agassiz)'],
  V0N: [51.294, -126.075, 'North Island, Sunshine Coast, and Southern Gulf Islands (Whistler)'],
  V0P: [49.887, -126.267, 'North Central Island and Bute Inlet Region (Gold River)'],
  V0R: [49.027, -124.846, 'Central Island (Chemainus)'],
  V0S: [48.543, -123.672, 'Juan de Fuca Shore (Sooke)'],
  V0T: [52.234, -126.213, 'Inside Passage and the Queen Charlottes (Queen Charlotte City)'],
  V0V: [53.972, -129.899, 'Lower Skeena (Port Edward)'],
  V0W: [59.638, -133.543, 'Atlin Region (Atlin)'],
  V0X: [49.369, -120.657, 'Similkameen (Hope)'],
  V1A: [49.683, -115.986, 'Kimberley'],
  V1B: [50.084, -118.938, 'Vernon East'],
  V1C: [49.500, -115.769, 'Cranbrook'],
  V1E: [50.700, -119.269, 'Salmon Arm'],
  V1G: [55.767, -120.236, 'Dawson Creek'],
  V1H: [50.287, -119.498, 'Vernon West'],
  V1J: [56.250, -120.853, 'Fort St. John'],
  V1K: [50.112, -120.794, 'Merritt'],
  V1L: [49.500, -117.285, 'Nelson'],
  V1M: [49.166, -122.579, 'Langley Township North'],
  V1N: [49.300, -117.669, 'Castlegar'],
  V1P: [49.896, -119.172, 'Kelowna East'],
  V1R: [49.100, -117.702, 'Trail'],
  V1S: [50.558, -120.548, 'Kamloops Southwest'],
  V1T: [50.260, -119.277, 'Vernon Central'],
  V1V: [49.950, -119.434, 'Kelowna North'],
  V1W: [49.812, -119.508, 'Kelowna Southwest'],
  V1X: [50.053, -119.286, 'Kelowna East Central'],
  V1Y: [49.893, -119.485, 'Kelowna Central'],
  V1Z: [49.862, -119.583, 'Kelowna West'],
  V2A: [49.481, -119.586, 'Penticton'],
  V2B: [50.887, -120.736, 'Kamloops Northwest'],
  V2C: [50.544, -120.094, 'Kamloops Central and Southeast'],
  V2E: [50.674, -120.421, 'Kamloops South and West'],
  V2G: [52.142, -122.144, 'Williams Lake'],
  V2H: [50.726, -120.166, 'Kamloops North'],
  V2J: [52.978, -122.493, 'Quesnel'],
  V2K: [54.051, -122.922, 'Prince George North'],
  V2L: [53.908, -122.747, 'Prince George East Central'],
  V2M: [53.913, -122.871, 'Prince George West Central'],
  V2N: [53.641, -122.954, 'Prince George South'],
  V2P: [49.184, -121.905, 'Chilliwack Central'],
  V2R: [49.076, -121.988, 'Chilliwack West'],
  V2S: [49.042, -122.284, 'Abbotsford Southeast'],
  V2T: [49.038, -122.349, 'Abbotsford Southwest'],
  V2V: [49.646, -122.505, 'Mission East'],
  V2W: [49.207, -122.485, 'Maple Ridge East'],
  V2X: [49.220, -122.616, 'Maple Ridge West'],
  V2Y: [49.129, -122.624, 'Langley Township Northwest'],
  V2Z: [49.048, -122.600, 'Langley Township Southwest'],
  V3A: [49.100, -122.653, 'Langley City'],
  V3B: [49.274, -122.765, 'Port Coquitlam Central'],
  V3C: [49.244, -122.787, 'Port Coquitlam South'],
  V3E: [49.317, -122.738, 'Port Coquitlam North'],
  V3G: [49.075, -122.178, 'Abbotsford East'],
  V3H: [49.323, -122.863, 'Port Moody'],
  V3J: [49.265, -122.872, 'Coquitlam North'],
  V3K: [49.237, -122.852, 'Coquitlam South'],
  V3L: [49.220, -122.900, 'New Westminster Northeast'],
  V3M: [49.189, -122.938, 'New Westminster Southwest (Includes Annacis Island)'],
  V3N: [49.227, -122.930, 'Burnaby (East Big Bend / Stride Avenue / Edmonds / Cariboo-Armstrong)'],
  V3R: [49.195, -122.813, 'Surrey North'],
  V3S: [49.079, -122.755, 'Surrey East'],
  V3T: [49.189, -122.845, 'Surrey Inner Northwest'],
  V3V: [49.189, -122.873, 'Surrey Outer Northwest'],
  V3W: [49.141, -122.857, 'Surrey Upper West'],
  V3X: [49.107, -122.858, 'Surrey Lower West'],
  V3Y: [49.221, -122.690, 'Pitt Meadows'],
  V3Z: [49.106, -122.825, 'Surrey'],
  V4A: [49.037, -122.830, 'Surrey Southwest'],
  V4B: [49.026, -122.806, 'White Rock'],
  V4C: [49.155, -122.912, 'Delta Northeast'],
  V4E: [49.120, -122.906, 'Delta East'],
  V4G: [49.146, -123.014, 'Delta East Central'],
  V4K: [49.099, -123.032, 'Delta Central'],
  V4L: [49.042, -123.059, 'Delta Southeast'],
  V4M: [49.033, -123.088, 'Delta Southwest'],
  V4N: [49.171, -122.733, 'Surrey Northeast'],
  V4P: [49.056, -122.830, 'Surrey South'],
  V4R: [49.290, -122.517, 'Maple Ridge Northwest'],
  V4S: [49.253, -122.357, 'Mission West'],
  V4T: [49.866, -119.739, 'Westbank'],
  V4V: [50.022, -119.405, 'Winfield'],
  V4W: [49.071, -122.498, 'Langley Township East'],
  V4X: [49.086, -122.403, 'Abbotsford West'],
  V4Z: [49.079, -121.610, 'Chilliwack East'],
  V5A: [49.264, -122.937, 'Burnaby (Government Road / Lake City / SFU / Burnaby Mountain)'],
  V5B: [49.277, -122.976, 'Burnaby (Parkcrest-Aubrey / Ardingley-Sprott)'],
  V5C: [49.274, -123.007, 'Burnaby (Burnaby Heights / Willingdon Heights / West Central Valley)'],
  V5E: [49.227, -122.957, 'Burnaby (Lakeview-Mayfield / Richmond Park / Kingsway-Beresford)'],
  V5G: [49.248, -122.994, 'Burnaby (Cascade-Schou / Douglas-Gilpin)'],
  V5H: [49.230, -122.995, 'Burnaby (Maywood / Marlborough / Oakalla / Windsor)'],
  V5J: [49.204, -122.992, 'Burnaby (Suncrest / Sussex-Nelson / Clinton-Glenwood / West Big Bend)'],
  V5K: [49.281, -123.040, 'Vancouver (North Hastings-Sunrise)'],
  V5L: [49.279, -123.067, 'Vancouver (North Grandview-Woodlands)'],
  V5M: [49.260, -123.040, 'Vancouver (South Hastings-Sunrise / North Renfrew-Collingwood)'],
  V5N: [49.255, -123.067, 'Vancouver (South Grandview-Woodlands / NE Kensington)'],
  V5P: [49.222, -123.068, 'Vancouver (SE Kensington / Victoria-Fraserview)'],
  V5R: [49.240, -123.041, 'Vancouver (South Renfrew-Collingwood)'],
  V5S: [49.218, -123.038, 'Vancouver (Killarney)'],
  V5T: [49.262, -123.092, 'Vancouver (East Mount Pleasant)'],
  V5V: [49.248, -123.091, 'Vancouver (West Kensington / NE Riley Park-Little Mountain)'],
  V5W: [49.233, -123.092, 'Vancouver (SE Riley Park-Little Mountain / SW Kensington / NE Oakridge / North Sunset)'],
  V5X: [49.216, -123.098, 'Vancouver (SE Oakridge / East Marpole / South Sunset)'],
  V5Y: [49.249, -123.110, 'Vancouver (West Mount Pleasant / West Riley Park-Little Mountain)'],
  V5Z: [49.248, -123.121, 'Vancouver (East Fairview / South Cambie)'],
  V6A: [49.278, -123.091, 'Vancouver (Strathcona / Chinatown / Downtown Eastside)'],
  V6B: [49.279, -123.114, 'Vancouver (NE Downtown / Harbour Centre / Gastown / Yaletown)'],
  V6C: [49.287, -123.116, 'Vancouver (Waterfront / Coal Harbour / Canada Place)'],
  V6E: [49.283, -123.130, 'Vancouver (South West End)'],
  V6G: [49.299, -123.141, 'Vancouver (North West End / Stanley Park)'],
  V6H: [49.256, -123.132, 'Vancouver (West Fairview / Granville Island / NE Shaughnessy)'],
  V6J: [49.260, -123.146, 'Vancouver (NW Shaughnessy / East Kitsilano / Quilchena)'],
  V6K: [49.265, -123.165, 'Vancouver (Central Kitsilano)'],
  V6L: [49.250, -123.166, 'Vancouver (NW Arbutus Ridge)'],
  V6M: [49.234, -123.145, 'Vancouver (South Shaughnessy / NW Oakridge / NE Kerrisdale / SE Arbutus Ridge)'],
  V6N: [49.230, -123.189, 'Vancouver (Dunbar-Southlands / Musqueam)'],
  V6P: [49.215, -123.140, 'Vancouver (SE Kerrisdale / SW Oakridge / West Marpole)'],
  V6R: [49.267, -123.198, 'Vancouver (West Kitsilano / Jericho)'],
  V6S: [49.249, -123.209, 'Vancouver (Chaldecutt / South University Endowment Lands)'],
  V6T: [49.464, -122.822, 'Vancouver (UBC)'],
  V6V: [49.185, -123.039, 'Richmond Northeast'],
  V6W: [49.153, -123.048, 'Richmond Southeast'],
  V6X: [49.184, -123.117, 'Richmond North'],
  V6Y: [49.170, -123.137, 'Richmond Central'],
  V6Z: [49.277, -123.130, 'Vancouver (SW Downtown)'],
  V7A: [49.120, -123.117, 'Richmond South'],
  V7B: [49.199, -123.180, 'Richmond (Sea Island / YVR)'],
  V7C: [49.163, -123.172, 'Richmond West'],
  V7E: [49.132, -123.171, 'Richmond Southwest'],
  V7G: [49.368, -122.928, 'North Vancouver Outer East'],
  V7H: [49.355, -122.980, 'North Vancouver Inner East'],
  V7J: [49.362, -123.018, 'North Vancouver East Central'],
  V7K: [49.360, -123.038, 'North Vancouver North Central'],
  V7L: [49.316, -123.058, 'North Vancouver South Central'],
  V7M: [49.322, -123.083, 'North Vancouver Southwest Central'],
  V7N: [49.350, -123.068, 'North Vancouver Northwest Central'],
  V7P: [49.322, -123.115, 'North Vancouver Southwest'],
  V7R: [49.377, -123.086, 'North Vancouver Northwest'],
  V7S: [49.374, -123.186, 'West Vancouver North'],
  V7T: [49.332, -123.142, 'West Vancouver Southeast'],
  V7V: [49.340, -123.191, 'West Vancouver South'],
  V7W: [49.361, -123.263, 'West Vancouver West'],
  V7X: [49.294, -123.116, 'Vancouver (Bentall Centre)'],
  V7Y: [49.282, -123.119, 'Vancouver (Pacific Centre)'],
  V8A: [50.016, -124.323, 'Powell River'],
  V8B: [49.700, -123.156, 'Squamish'],
  V8C: [54.052, -128.653, 'Kitimat'],
  V8E: [50.118, -122.954, 'Whistler'],
  V8G: [54.516, -128.603, 'Terrace'],
  V8J: [54.316, -130.320, 'Prince Rupert'],
  V8K: [48.814, -123.497, 'Saltspring Island'],
  V8L: [48.650, -123.403, 'Sidney'],
  V8M: [48.566, -123.419, 'Central Saanich'],
  V8N: [48.477, -123.314, 'Saanich East'],
  V8P: [48.458, -123.332, 'Saanich Southeast'],
  V8R: [48.450, -123.303, 'Oak Bay North'],
  V8S: [48.420, -123.305, 'Oak Bay South'],
  V8T: [48.439, -123.357, 'Victoria North'],
  V8V: [48.417, -123.365, 'Victoria South'],
  V8W: [48.427, -123.365, 'Victoria Central British Columbia Provincial Government'],
  V8X: [48.478, -123.366, 'Saanich South'],
  V8Y: [48.525, -123.374, 'Saanich North'],
  V8Z: [48.499, -123.400, 'Saanich Central'],
  V9A: [48.450, -123.419, 'Esquimalt'],
  V9B: [48.479, -123.527, 'Highlands'],
  V9C: [48.383, -123.536, 'Metchosin'],
  V9E: [48.522, -123.453, 'Saanich West'],
  V9G: [48.983, -123.819, 'Ladysmith'],
  V9H: [49.909, -125.586, 'Campbell River Outskirts'],
  V9J: [49.724, -125.260, 'Courtenay Northern Outskirts'],
  V9K: [49.347, -124.436, 'Qualicum Beach'],
  V9L: [48.783, -123.703, 'Duncan'],
  V9M: [49.683, -124.936, 'Comox'],
  V9N: [49.658, -124.984, 'Courtenay Central'],
  V9P: [49.316, -124.319, 'Parksville'],
  V9R: [49.161, -123.983, 'Nanaimo South'],
  V9S: [49.189, -123.963, 'Nanaimo Central'],
  V9T: [49.215, -124.020, 'Nanaimo North'],
  V9V: [49.239, -124.023, 'Nanaimo Northwest'],
  V9W: [50.077, -125.591, 'Campbell River Central'],
  V9X: [49.042, -123.979, 'Cedar'],
  V9Y: [49.241, -124.803, 'Port Alberni'],
  V9Z: [48.375, -123.728, 'Sooke'],
  X0A: [79.622, -76.776, 'Outer Nunavut (Iqaluit)'],
  X0B: [70.907, -106.960, 'Central Nunavut (Cambridge Bay)'],
  X0C: [64.165, -94.772, 'Inner Nunavut (Rankin Inlet)'],
  X0E: [66.871, -120.225, 'Central Northwest Territories (Inuvik)'],
  X0G: [60.256, -123.383, 'Southwestern Northwest Territories (Fort Liard)'],
  X1A: [62.456, -114.353, 'Yellowknife'],
  Y0A: [61.579, -131.148, 'Southeastern Yukon (Watson Lake)'],
  Y0B: [64.645, -137.536, 'Central Yukon (Dawson City)'],
  Y1A: [60.716, -135.054, 'Whitehorse'],
};
